var vMobilesize = 841;
var vyourinspcnt = 11;
var vTimer;
 
var configtabclick = 0;
var cammiejs = {
    ddclick: function(obj) {
        $(obj).attr('tabindex', 1).focus();
        $(obj).toggleClass('active');
        $(obj).find('.dropdown-menu').slideToggle(300);
    },
    ddfoucsout: function(obj) {
        $(obj).removeClass('active');
        $(obj).find('.dropdown-menu').slideUp(300);
    },
    validateemail: function(mail) {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (mail.match(mailformat)) {
            return true;
        }
        return false;
    },
    joincommunity: function() {
        var vResult = cammiejs.validateemail($('.newslttr').val());
        var vtboxobj = $('.newslttr').closest('.jcc_tbox');
        vtboxobj.removeClass('error');
        $('#ContactFooter-success').remove();
        if (!vResult) {
            vtboxobj.addClass('error').find('.error_txt').html('Please enter a valid email address');
        }
        return vResult;
    },
    sharePopupOpen: function() {
        $('#shareNetworkButtons').css("display", "flex");
        var vshareurl = 'https://www.cammie.com' + cammiejs.getshareurl();
        $('#txtShare').val(vshareurl);
        $('.st-custom-button').attr('data-url', vshareurl);
    },
    sharePopupClose: function() {
        $('#shareNetworkButtons').hide();
    },
    shareurlcopy: function() {
        var copyText = document.getElementById("txtShare");
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(copyText.value);
    },
    getyourdesignall: function() {
        $.post("https://api.cammie.com/getyourdesigns", function(data, status) {
            console.log("Data: " + data + "\nStatus: " + status);
        });
    },
    getyourdesignbykey: function(vdata) {
        $.post("https://api.cammie.com/getyourdesignsbykey", vdata, function(data, status) {
            console.log("Data: " + data + "\nStatus: " + status);
        });
    },
    putyourdesigns: function(vdata) {
        $.post("https://api.cammie.com/putyourdesigns", vdata, function(data, status) {
            console.log("Data: " + data + "\nStatus: " + status);
        });
    },
    review: {
        init: function() {
            if ($('.jdgm-link').length > 0) {
                $('.jdgm-link').text(parseFloat($('.jdgm-link').text()).toFixed(1));
            }
        }
    },
    cookiename: "cartcammie_v4",
    yourdesignfrom: "1",
    getimgpopupopen: function(obj) {

        $('#imgShowPopup .get_big_img').attr('src', $(obj).attr('data-bigurl'));
        $('#imgShowPopup').css('display', 'flex');
    },
    getimgpopupclose: function(imgurl) {
        $('#imgShowPopup').css('display', 'none');
    },
    homeinspipopupclose: function(obj) {

        $(obj).closest('.gics_popup').removeClass('active');
    },
    homeinspipopup: function(obj, hdn, img, name, bigimg) {
        var vobjWidth = $(obj).closest('.gics_img').width();
        var vobjHeight = $(obj).closest('.gics_img').height();
        var vele = $(obj).closest('.gici_point').next('.gics_popup');
        vele.addClass('active');
        var vpopobjWidth = vele.outerWidth(true);
        var vpopobjHeight = vele.outerHeight(true);
        vele.find('h4').html(hdn);
        vele.find('img').attr('src', img).attr('data-bigurl', bigimg);
        vele.find('p').html(name);
        var vleft = $(obj).position().left + $(obj).outerWidth(true);
        if ((vleft + vpopobjWidth) > vobjWidth) {
            vleft = $(obj).position().left - vpopobjWidth;
        }
        var vtop = $(obj).position().top + $(obj).outerHeight(true);
        if ((vtop + vpopobjHeight) > vobjHeight) {
            vtop = $(obj).position().top - vpopobjHeight;
            if (vtop < 0) {
                vtop = 0;
            }
        }
        vele.css({
            'left': vleft,
            "top": vtop
        });
    },
    handleErrorMessage: function(page, errorText) {
        var pdpsetelement = document.getElementById("pdpsetError");
        var pdpIndividualelement = document.getElementById("pdpIndividualError");

        if (pdpsetelement != null && page == 'Set') {
            pdpsetelement.classList.remove("hidden");
            pdpsetErrorText.innerHTML = errorText;
        } else if (pdpIndividualelement != null && page == 'Individual') {
            pdpIndividualelement.classList.remove("hidden");
            pdpIndividualErrorText.innerHTML = errorText;
        }
    },
    pdpErrorClose: function(page) {
        var pdpsetelement = document.getElementById("pdpsetError");
        var pdpIndividualelement = document.getElementById("pdpIndividualError");

        if (pdpsetelement != null && page == 'Set') {
            pdpsetelement.classList.add("hidden");
            pdpsetErrorText.innerHTML = '';
        } else if (pdpIndividualelement != null && page == 'Individual') {
            pdpIndividualelement.classList.add("hidden");
            pdpIndividualErrorText.innerHTML = '';
        }


    },
addtocartdd:function(obj) {
  $(obj).closest('.dropdown').find('.select span').html($(obj).attr('data-value'));
},
    addtocart: function(page) {

        // changes starts here
        var variantIdInput = '';
        var variantQuantityInput = '';
        var variantColorInput = '';

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        //this.submitButton = this.querySelector('[type="submit"]');

        const PdpSetAddtoCartElement = document.getElementById("setAddtoCart");
        const PdpIndividualAddtoCartElement = document.getElementById("IndividualAddtoCart");

        /*console.log('PdpSetAddtoCartElement ' + PdpSetAddtoCartElement);
    console.log('PdpIndividualAddtoCartElement ' + PdpIndividualAddtoCartElement);
 */
        if (PdpSetAddtoCartElement != null)
            if (document.querySelector('cart-drawer')) PdpSetAddtoCartElement.setAttribute('aria-haspopup', 'dialog');
            else if (PdpSetAddtoCartElement != null)
            if (document.querySelector('cart-drawer')) PdpIndividualAddtoCartElement.setAttribute('aria-haspopup', 'dialog');
        //evt.preventDefault();


        var bundleValue = cammiejs.generateString(5);
        if($('#hptype').val() == "3")
        {
          bundleValue = "";
        }

        var type = $('#hptype').val();
        var multipleProductInput = {
            'items': []
        };
var vquantity = 1;
      if($('#IndividualAddtoCartCount').length > 0){
        vquantity = Number($('#IndividualAddtoCartCount .select span').text());
      }
        var vcart = {
            'id': 0,
            'quantity': vquantity,
            'Color': '',
            'sections_url': window.location.pathname,
            'properties': {
                '_Bundle': bundleValue,
                '_IsBundle': 0,
                '_Affiliate':''
            }
        };
        if (type == "1") {
            $('.side_svg_view svg').each(function() {
                var vColorCode = $(this).find('path').attr('fill');
                var vcartObj = JSON.parse(JSON.stringify(vcart));
                var vName = $(this).attr('class').replace('svg_', '');
                vcartObj.id = vProductCardData[$('#hSize').val()][vName][vColorCode].id;
                /*if ($('#hSize').val() != 'twin' && ($(this).attr('class') == "svg_pillowcase" || $(this).attr('class') == "svg_sham")) {
                    vcartObj.quantity = 2;
                }*/
                vcartObj.Color = vProductCardData[$('#hSize').val()][vName][vColorCode].name;
                vcartObj.properties._IsBundle = 1;
                var vclrcode = $(this).find('path').attr('fill')
                if(vclrcode == "#862132" || vclrcode == "#ceb00d" || vclrcode == "#6198ae" || vclrcode == "#c0aac0")
                {
                  vcartObj.properties["_Affiliate"] = "Apartment Therapy x Cammie";
                }
                multipleProductInput.items.push(vcartObj);
            });
        } else if (type == "3") {
            $('.svg_view_img:first svg').each(function() {
                var vColorCode = $(this).find('path').attr('fill');
                var vcartObj = JSON.parse(JSON.stringify(vcart));
                var vName = $(this).attr('class').replace('svg_', '');
                vcartObj.id = vProductCardData[$('#hSize').val()][vName][vColorCode].id;
                vcartObj.Color = vProductCardData[$('#hSize').val()][vName][vColorCode].name;
                var vclrcode = $(this).find('path').attr('fill')
                if(vclrcode == "#862132" || vclrcode == "#ceb00d" || vclrcode == "#6198ae" || vclrcode == "#c0aac0")
                {
                  vcartObj.properties["_Affiliate"] = "Apartment Therapy x Cammie";
                }
                multipleProductInput.items.push(vcartObj);
            });
        } else if (type == "4") {
            var vcartObj = JSON.parse(JSON.stringify(vcart));

            vcartObj.id = $('#hpswatchid').val();               
            multipleProductInput.items.push(vcartObj);
        }
        /*console.log(multipleProductInput);*/
        if (multipleProductInput.items.length > 0) {
            variantIdInput = multipleProductInput.items[multipleProductInput.items.length - 1].id;
            variantQuantityInput = multipleProductInput.items[multipleProductInput.items.length - 1].quantity;
            variantColorInput = multipleProductInput.items[multipleProductInput.items.length - 1].Color;
            variantProductType =  multipleProductInput.items[multipleProductInput.items.length - 1]["properties"]._Affiliate;
        }

        if (multipleProductInput.items.length == 1) {
            //console.log('1' + variantIdInput, variantQuantityInput, variantColorInput);
            this.singleProductUpate(variantIdInput, variantQuantityInput, variantColorInput, bundleValue, page, 0,variantProductType);
        } else if (multipleProductInput.items.length > 1) {
            //console.log('2' + multipleProductInput, variantIdInput, variantQuantityInput, variantColorInput);
            this.multipleProductInput(multipleProductInput, variantIdInput, variantQuantityInput, variantColorInput, bundleValue, page,variantProductType);
        }
        /*console.log('multipleProductInput ' + JSON.stringify(multipleProductInput));*/

    },

    multipleProductInput1(multipleProductInput, variantIdInput, variantQuantityInput, variantColorInput, bundleValue, page,productyype) {

        /*
        //var multipleProductInputCopy =  $.extend(true,{},multipleProductInput);
        //var multipleProductInputCopy = multipleProductInput;
          
        var multipleProductInputCopyWithoutLastItem = multipleProductInputCopy.items.splice(0, multipleProductInputCopy.items.length-1);

        console.log('multipleProductInputCopy ' + JSON.stringify(multipleProductInputCopy));
        console.log('multipleProductInputCopyWithoutLastItem ' + JSON.stringify(multipleProductInputCopyWithoutLastItem));
        console.log('multipleProductInput ' + JSON.stringify(multipleProductInput));*/

        var multipleProductInputCopy = {
            'items': []
        };
        for (var i = 0; i < multipleProductInput.items.length - 1; i++) {
            multipleProductInputCopy.items.push(multipleProductInput.items[i]);
        }

        //console.log('popped ' + JSON.stringify(multipleProductInputCopy));
        //console.log('popped1 ' + JSON.stringify(multipleProductInput));     
    },

    multipleProductInput(multipleProductInput, variantIdInput, variantQuantityInput, variantColorInput, bundleValue, page,productyype) {
        //console.log(JSON.stringify(multipleProductInput));

        //var multipleProductInputCopy = JSON.stringify(multipleProductInput.items.splice(0, multipleProductInput.items.length-1));

        var multipleProductInputCopy = {
            'items': []
        };
        for (var i = 0; i < multipleProductInput.items.length - 1; i++) {
            multipleProductInputCopy.items.push(multipleProductInput.items[i]);
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(multipleProductInputCopy)
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(page, response.description);

                    /*const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    PdpSetAddtoCartElement.setAttribute('aria-disabled', true);
                    PdpSetAddtoCartElement.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;*/
                    return;
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }

                this.error = false;
                //const quickAddModal = this.closest('quick-add-modal');

                this.singleProductUpate(variantIdInput, variantQuantityInput, variantColorInput, bundleValue, page, 1,productyype);

                /*if (quickAddModal) {
                  document.body.addEventListener('modalClosed', () => {
                    setTimeout(() => { this.cart.renderContents(response) });
                  }, { once: true });
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }*/
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                /*this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');*/
            });
    },

    singleProductUpate(variantIdInput, variantQuantityInput, variantColorInput, bundleValue, page, isbundle,productyype) {

        /* console.log(variantIdInput);   
         console.log(variantQuantityInput);
         console.log(variantColorInput);*/

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        //const formData = new FormData(this.form);
        const formData = new FormData();



        if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            //formData.append("properties[key]", '_Bundle');
            formData.append("properties[_Bundle]", bundleValue);
            formData.append("properties[_IsBundle]", isbundle);
            formData.append("properties[_Affiliate]",productyype)
            this.cart.setActiveElement(document.activeElement);
        }

        formData.append('id', variantIdInput);
        formData.append('quantity', variantQuantityInput);
        formData.append('Color', variantColorInput);


        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(page, response.description);

                    /*const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    PdpSetAddtoCartElement.setAttribute('aria-disabled', true);
                    PdpSetAddtoCartElement.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;*/
                    return;
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }

                this.error = false;
                /*
                const quickAddModal = document.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener('modalClosed', () => {
                    setTimeout(() => { this.cart.renderContents(response) });
                  }, { once: true });
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }*/

                this.cart.renderContents(response);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                /*this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');*/
            });

    },
    generateString: function(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },

    stgname: "cammie_v7",
    getPDPIndividualPage: function(obj) {
        var vURL = $(obj).attr('data-url');


        var vlstacttabelem = "";
        var vvTabData = JSON.parse(cammiejs.getlatesttabelem());
        if (Object.keys(vvTabData).length > 0) {
            vlstacttabelem = vvTabData['lasttabeleclicked'];
        }
        if (vlstacttabelem == "color-group-btn") {
            var vname = $('#color-group-wrapper .pscl_listed li[data-id="' + vvTabData['colorgroup'] + '"]').attr('data-colorurl');
            vURL = vURL + '/' + vname;
        } else if (vlstacttabelem == "color-all-btn") {
            var vname = $('#color-all-wrapper .pscl_listed li[data-id="' + vvTabData['colorall'] + '"]').attr('data-colorurl');
            vURL = vURL + '/' + vname;
        }



        /*if(($('#color-group-btn').hasClass('active') && $('#color-group-wrapper .pscl_listed li a.active')) || 
       ($('#color-all-btn').hasClass('active') && $('#color-all-wrapper .pscl_listed li a.active')))
    {
      vURL = vURL + 'color-' + $('#color-all-wrapper .pscl_listed li a.active').closest('li').attr('data-id');
    } */
        fetch(vURL).then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                $('title').html($(html).find('title').html());
                cammiejs.updatereplaceurl($('head title').text(), vURL);
                $('.pss_left_card').html($(html).find('.pss_left_card').html());
                $('.pss_right_card').html($(html).find('.pss_right_card').html());
                $('.fixed_footer').html($(html).find('.fixed_footer').html());
                $('#reviews').html($(html).find('#reviews').html());
                cammiejs.loadAccordion();
                cammiejs.loadpdppage();
                var vTabData = JSON.parse(cammiejs.getlatesttabelem());
                if (Object.keys(vTabData).length > 0) {

                    if (vTabData.hasOwnProperty('colorgroup') && vTabData.hasOwnProperty('lasttabeleclicked') && vTabData['lasttabeleclicked'] == 'color-group-btn') {
                        $('#color-group-wrapper .pscl_listed li a.active').removeClass('active');
                        $('#color-group-wrapper .pscl_listed li[data-id="' + vTabData['colorgroup'] + '"]').find('a').addClass('active');
                    }
                    if (vTabData.hasOwnProperty('colorall') && vTabData.hasOwnProperty('lasttabeleclicked') && vTabData['lasttabeleclicked'] == 'color-all-btn') {
                        $('#color-all-wrapper .pscl_listed li a.active').removeClass('active');
                        $('#color-all-wrapper .pscl_listed li[data-id="' + vTabData['colorall'] + '"]').find('a').addClass('active');
                    }

                    if (vTabData.hasOwnProperty('lasttabactive')) {
                        $('#' + vTabData['lasttabactive']).click();
                    }

                }
            });
    },
    localget: function() {
        var vUData = window.localStorage.getItem(cammiejs.stgname);
        if (vUData != null) {
            vUData = JSON.parse(vUData);
        } else {
            vUData = [];
        }
        return vUData;
    },
    localset: function(vItem) {
        var vUData = cammiejs.localget();
        var vnewKey = Object.keys(vItem)[0];

        var vUDataNew = [];

        $.each(vUData, function(index, vyjdata) {

            if (Object.keys(vyjdata)[0] == vnewKey) {
                if (vItem[vnewKey] != vyjdata[vnewKey]) {
                    var vskey = vnewKey;
                    var vDone = {};
                    vDone[vskey] = vyjdata[vnewKey];
                    vUDataNew.push(vDone);
                }
            } else {
                vUDataNew.push(vyjdata);
            }

        });


        if (vUDataNew.length > vyourinspcnt) {
            vUDataNew.shift();
        }
        vUDataNew.push(vItem);
        window.localStorage.setItem(cammiejs.stgname, JSON.stringify(vUDataNew));
    },
    getshareurl: function() {
        var vurls = "/collections/"+ $('.dropdown-menu .active').attr('data-rurl') + "/cust?id=";
        vurls += cammiejs.get2digitval(vcodename[$('svg.svg_fitted-sheet:first path:first').attr('fill')].id + "");
        vurls += cammiejs.get2digitval(vcodename[$('svg.svg_flat-sheet:first path:first').attr('fill')].id + "");
        vurls += cammiejs.get2digitval(vcodename[$('svg.svg_pillowcase:first path:first').attr('fill')].id + "");
        if ($('#hbundletype').val() == "1") {
            vurls += cammiejs.get2digitval(vcodename[$('svg.svg_sham:first path:first').attr('fill')].id + "");
            vurls += cammiejs.get2digitval(vcodename[$('svg.svg_duvet-cover:first path:first').attr('fill')].id + "");          
        }
        return vurls;
    },
    get2digitval: function(colorid) {
        if (colorid.length == 1) {
            colorid = "0" + colorid;
        }
        return colorid;
    },
    loadconfigcustompage: function() {
 
       
          
                        var vnewKey = $('#hcustinspid').val();
         if(vnewKey.length > 0)
         {
                        var vnewKeyarray = vnewKey.match(/.{1,2}/g);
                        for (let index = 0; index < vnewKeyarray.length; ++index) {
                           vnewKeyarray[index] = Number(vnewKeyarray[index]);
                        }
           
                        var eletoChange = $('.svg_fitted-sheet,li[data-ele="rgt_fitted-sheet"]');
                        eletoChange.find('path').attr('fill',cammiejs.getcolorcodebyidfobj(vnewKeyarray[0]));
                        $('li[data-ele="rgt_fitted-sheet"]').attr('data-icolor-name', vcodename[cammiejs.getcolorcodebyidfobj(vnewKeyarray[0])].name).attr('data-icolor-code', cammiejs.getcolorcodebyidfobj(vnewKeyarray[0]));
                        $('li[data-ele="rgt_fitted-sheet"] .color-name').html(vcodename[cammiejs.getcolorcodebyidfobj(vnewKeyarray[0])].name);
                        var velems = $('.hsit_fittedsheet,.ssit_fittedsheet');
                        cammiejs.removeColorClass(velems);
                        velems.addClass('color_'+vnewKeyarray[0]);
                      
                        var eletoChange = $('.svg_flat-sheet,li[data-ele="rgt_flat-sheet"]');
                        eletoChange.find('path').attr('fill', cammiejs.getcolorcodebyidfobj(vnewKeyarray[1]));
                        $('li[data-ele="rgt_flat-sheet"]').attr('data-icolor-name', vcodename[cammiejs.getcolorcodebyidfobj(vnewKeyarray[1])].name).attr('data-icolor-code', cammiejs.getcolorcodebyidfobj(vnewKeyarray[1]));
                        $('li[data-ele="rgt_flat-sheet"] .color-name').html(vcodename[cammiejs.getcolorcodebyidfobj(vnewKeyarray[1])].name);
                        var velems = $('.hsit_flatsheet,.ssit_flatsheet');
                        cammiejs.removeColorClass(velems);
                        velems.addClass('color_'+vnewKeyarray[1]);
                      
                        var eletoChange = $('.svg_pillowcase,li[data-ele="rgt_pillowcase"]');
                        eletoChange.find('path').attr('fill', cammiejs.getcolorcodebyidfobj(vnewKeyarray[2]));
                        $('li[data-ele="rgt_pillowcase"]').attr('data-icolor-name', vcodename[cammiejs.getcolorcodebyidfobj(vnewKeyarray[2])].name).attr('data-icolor-code', cammiejs.getcolorcodebyidfobj(vnewKeyarray[2]));
                        $('li[data-ele="rgt_pillowcase"] .color-name').html(vcodename[cammiejs.getcolorcodebyidfobj(vnewKeyarray[2])].name);
                        var velems = $('.hsit_pillow,.ssit_pillow');
                        cammiejs.removeColorClass(velems);
                        velems.addClass('color_'+vnewKeyarray[2]);
                      
                        var eletoChange = $('.svg_sham,li[data-ele="rgt_sham"]');
                       if(eletoChange.length > 0)
                       {
                          eletoChange.find('path').attr('fill', cammiejs.getcolorcodebyidfobj(vnewKeyarray[3]));
                          $('li[data-ele="rgt_sham"]').attr('data-icolor-name', vcodename[ cammiejs.getcolorcodebyidfobj(vnewKeyarray[3])].name).attr('data-icolor-code',cammiejs.getcolorcodebyidfobj(vnewKeyarray[3]));
                          $('li[data-ele="rgt_sham"] .color-name').html(vcodename[cammiejs.getcolorcodebyidfobj(vnewKeyarray[3])].name);
                          var velems = $('.hsit_sham,.ssit_sham');
                          cammiejs.removeColorClass(velems);
                          velems.addClass('color_'+vnewKeyarray[3]);                         
                       }

                        var eletoChange = $('.svg_duvet-cover,li[data-ele="rgt_duvet-cover"]');
                       if(eletoChange.length > 0)
                       {
                          eletoChange.find('path').attr('fill', cammiejs.getcolorcodebyidfobj(vnewKeyarray[4]));
                          $('li[data-ele="rgt_duvet-cover"]').attr('data-icolor-name', vcodename[cammiejs.getcolorcodebyidfobj(vnewKeyarray[4])].name).attr('data-icolor-code', cammiejs.getcolorcodebyidfobj(vnewKeyarray[4]));
                          $('li[data-ele="rgt_duvet-cover"] .color-name').html(vcodename[cammiejs.getcolorcodebyidfobj(vnewKeyarray[4])].name);
                          var velems = $('.hsit_duvetcover,.ssit_duvetcover');
                          cammiejs.removeColorClass(velems);
                          velems.addClass('color_'+vnewKeyarray[4]);                           
                       }
           
             $('.pss_header_card li.active').click(); 
         }
                    
 
    },
  getquerystring:function(name) {
     const urlParams = new URLSearchParams(window.location.search);
            const vcustid = urlParams.get(name);
    return vcustid;
  },
 getcolorcodebyidfobj:function(id){   
    var vcode = "";        
    Object.keys(vcodename).forEach(function(k, v){
      if(vcodename[k].id == id)
      {
        vcode = k;
      }
    });
    return vcode;    
  },
  getcolorcodebyid:function(id){
    var vcode = "";        
    vcode = $('#color-group-wrapper li[data-id="'+id+'"]').attr('data-colorcode');
    return vcode;    
  },
    loadyourdesign: function() { 
           
            const vcustid = cammiejs.getquerystring('id');
           if ($('#hcustinspid').val().length > 0) {
            $('#mixmatchurl,.mixmatchurl').attr('href',$('#mixmatchurl').attr('data-href') + vcustid);
            $('#hcustinspid').val(vcustid);
           }
        var vUData = cammiejs.localget();
        if (vUData.length > 0) {
           
            $('#color-yourdesign-wrapper .pscl_color_plt').html('');
            var vcno = vUData.length;
            $.each(vUData.reverse(), function(index, vyjdata) {
                var vcarray = vyjdata[Object.keys(vyjdata)[0]].split("|");
                var vbundletype = "1";
                if (vcarray.length > 1) {
                    vbundletype = vcarray[1];
                }

                if (vbundletype == $('#hbundletype').val()) {
                    var vydehtml = $($('#yourdesign-html-syntex').html());
                    vydehtml.addClass('collection'+vcarray[1]);
                    var vinspname = 'Your Design ' + (vcno);
                    vcno = vcno - 1;
                    vydehtml.find('h5').html(vinspname);
                    var vaobj = vydehtml.find('a[data-href]');


                    vydehtml.find('a[data-href]').addClass(vcarray[0]).attr('data-size', vcarray[0]).attr('data-href', vydehtml.find('a[data-href]').attr('data-href').replace('queen', vcarray[0]))
                        .attr('href', vydehtml.find('a[data-href]').attr('data-href').replace('queen', vcarray[0]).replace('/pages/', '/collections/') + '/cust?id=' + Object.keys(vyjdata)[0]);
                    vydehtml.find('.psmc_img_card img').attr('src', vydehtml.find('.psmc_img_card img').attr('src').replace('queen', vcarray[0]).replace('bed_1_', 'bed_' + vbundletype + '_'));
                    vydehtml.find('.psmc_img_card img').before($('#' + vbundletype + '-yst-' + vcarray[0]).html());

                    $.each(window['v_hyd_' + vbundletype + '_' + vcarray[0]].h, function(index, value) {
                        var vClass = "";
                        var vvaluea = value.split(':')
                        vydehtml.find('.psmc_img_card img:first').after('<img src="' + vvaluea[1] + '" alt="" title="" class="psic_highlight_img ' + vvaluea[0] + '" />');
                    });

                    $.each(window['v_hyd_' + vbundletype + '_' + vcarray[0]].s, function(index, value) {
                        var vvaluea = value.split(':')
                        vydehtml.find('.psmc_img_card img:first').after('<img src="' + vvaluea[1] + '" alt="" title="" class="psic_shadow_img ' + vvaluea[0] + '" />');
                    });
                    var vnewKey =Object.keys(vyjdata)[0];
                    var vnewKeyarray = vnewKey.match(/.{1,2}/g);
                  for (let index = 0; index < vnewKeyarray.length; ++index) {
                           vnewKeyarray[index] = Number(vnewKeyarray[index]);
                        }
                    vaobj.attr('data-name', vinspname);
                    vaobj.attr('data-href', vaobj.attr('data-href') + '/cust?id=' + vnewKey);
                    vaobj.attr('data-id', vnewKey);
                    vaobj.attr('data-fitted-sheet-code', cammiejs.getcolorcodebyid(vnewKeyarray[0]));
                    vydehtml.find('.hsit_fittedsheet,.ssit_fittedsheet').addClass('color_' + vnewKeyarray[0]);
                    vaobj.attr('data-flat-sheet-code', cammiejs.getcolorcodebyid(vnewKeyarray[1]));
                    vydehtml.find('.hsit_flatsheet,.ssit_flatsheet').addClass('color_' + vnewKeyarray[1]);
                    vaobj.attr('data-pillowcase-code', cammiejs.getcolorcodebyid(vnewKeyarray[2]));
                    vydehtml.find('.hsit_pillow,.ssit_pillow').addClass('color_' + vnewKeyarray[2]);
                    vaobj.attr('data-sham-code',cammiejs.getcolorcodebyid(vnewKeyarray[3]));
                    vaobj.attr('data-duvet-cover-code', cammiejs.getcolorcodebyid(vnewKeyarray[4]));
                    if (vbundletype == "1") {
                        vaobj.find('svg').eq(0).find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[4]));
                        vydehtml.find('.hsit_duvetcover,.ssit_duvetcover').addClass('color_' + vnewKeyarray[4]);
                        vaobj.find('svg').eq(1).find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[0]));
                        vaobj.find('svg').eq(2).find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[1]));
                        vaobj.find('svg').eq(3).find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[2]));
                        vaobj.find('svg').eq(4).find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[3]));
                        vydehtml.find('.hsit_sham,.ssit_sham').addClass('color_' + vnewKeyarray[3]);
                    } else {
                        vaobj.find('svg').eq(0).find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[0]));
                        vaobj.find('svg').eq(1).find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[1]));
                        vaobj.find('svg').eq(2).find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[2]));
                    }
                    $('#color-yourdesign-wrapper .pscl_color_plt').append(vydehtml);
                }
            });
          if($('#color-yourdesign-wrapper .pscl_color_plt li').length > 0)
          {
            $('#color-yourdesign-btn').show();
          }
            $('#color-yourdesign-count').html('(' + $('#color-yourdesign-wrapper .pscl_color_plt li').length + ')');
        }
    },
    makeid: function(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    },
    configdone: function(obj, ctype) {
        var vDone = {};
       
       var vValue =  $('#hprodsize').val() + '|' + $('#hbundletype').val();
       
        var vskey = "";
        var vSaveLocal = true;
      
        var vnewValue = cammiejs.getColorClass($('.pss_left_card  .psic_highlight_img.hsit_fittedsheet')).replace("color_","").padStart(2,0);
        vnewValue +=  cammiejs.getColorClass($('.pss_left_card  .psic_highlight_img.hsit_flatsheet')).replace("color_","").padStart(2,0);
        vnewValue +=  cammiejs.getColorClass($('.pss_left_card  .psic_highlight_img.hsit_pillow')).replace("color_","").padStart(2,0);
      
        if($('.pss_left_card  .psic_highlight_img.hsit_sham').length >0)
        vnewValue +=  cammiejs.getColorClass($('.pss_left_card  .psic_highlight_img.hsit_sham')).replace("color_","").padStart(2,0);
        if($('.pss_left_card  .psic_highlight_img.hsit_duvetcover').length >0)
        vnewValue +=  cammiejs.getColorClass($('.pss_left_card  .psic_highlight_img.hsit_duvetcover')).replace("color_","").padStart(2,0);

        var voldValue = vcodename[$('li[data-ele="rgt_fitted-sheet"]').attr('data-icolor-code')].id + vcodename[$('li[data-ele="rgt_flat-sheet"]').attr('data-icolor-code')].id;
        voldValue +=  vcodename[$('li[data-ele="rgt_pillowcase"]').attr('data-icolor-code')].id;
       if($('.pss_left_card  .psic_highlight_img.hsit_sham').length >0)
        voldValue +=    vcodename[$('li[data-ele="rgt_sham"]').attr('data-icolor-code')].id + vcodename[$('li[data-ele="rgt_duvet-cover"]').attr('data-icolor-code')].id;
       
        if (vnewValue == "4040404040" || vnewValue == "404040") {
            vSaveLocal = false;
        }

        if (vSaveLocal) {
            vskey = vnewValue;
            /*if ($('#hcustinspid').val().length > 0) {
                vskey = $('#hcustinspid').val();
            }*/
            vDone[vskey] = vValue;
            cammiejs.localset(vDone);
            vskey = "cust?id=" + vnewValue;
        }
        var vdURL = "";
        if (vskey.length == 0) {
            vdURL = $('link[rel="canonical"]').attr('href').replace('pages', 'collections');
        } else {
            vdURL = $(obj).attr('data-url') + vskey;
        }
        if (ctype == 2) {
            cammiejs.setCookiev1('sac', 1, 1);
        }
        window.location.href = vdURL;
    },
    loadpdppage: function() {

        $('.clr_fitted-sheet').html($('.pscl_listed li[data-colorcode="' + $('.svg_fitted-sheet path').attr('fill') + '"]').attr('data-name'));
        $('.clr_flat-sheet').html($('.pscl_listed li[data-colorcode="' + $('.svg_flat-sheet path').attr('fill') + '"]').attr('data-name'));
        $('.clr_pillowcase').html($('.pscl_listed li[data-colorcode="' + $('.svg_pillowcase path').attr('fill') + '"]').attr('data-name'));
        $('.clr_sham').html($('.pscl_listed li[data-colorcode="' + $('.svg_sham path').attr('fill') + '"]').attr('data-name'));
        $('.clr_duvet-cover').html($('.pscl_listed li[data-colorcode="' + $('.svg_duvet-cover path').attr('fill') + '"]').attr('data-name'));

        $('.clr_fitted-sheet').closest('li').find('.accl_color_plt span').css('background', $('.svg_fitted-sheet path').attr('fill'));
        $('.clr_flat-sheet').closest('li').find('.accl_color_plt span').css('background', $('.svg_flat-sheet path').attr('fill'));
        $('.clr_pillowcase').closest('li').find('.accl_color_plt span').css('background', $('.svg_pillowcase path').attr('fill'));
        $('.clr_sham').closest('li').find('.accl_color_plt span').css('background', $('.svg_sham path').attr('fill'));
        $('.clr_duvet-cover').closest('li').find('.accl_color_plt span').css('background', $('.svg_duvet-cover path').attr('fill'));

    },
    loadAccordion: function() {

        if ($('.accordion').length > 0) {
            var acc = document.getElementsByClassName("accordion");
            var i;

            for (i = 0; i < acc.length; i++) {
                acc[i].addEventListener("click", function() {
                    this.classList.toggle("active");
                    var panel = this.nextElementSibling;
                    if (panel.style.display === "block") {
                        $(panel).slideUp();
                    } else {
                        $(panel).slideDown();
                    }
                });
            }
        }


    },
    getpreviousprod: function() {
        $('.pss_header_card li.active').prev().click();
    },
    getnextprod: function() {
        $('.pss_header_card li.active').next().click();
    },
    getConfigPage: function(obj) {
        var vcurrtele = $(obj);
        var eletoChange = $('li[data-ele="rgt_fitted-sheet"]');
        var vfittedsheetC = eletoChange.find('#product-svg path').attr('fill');
        var vfittedsheetN = eletoChange.find('.color-name').html();
        var vfittedsheetDC = eletoChange.attr('data-icolor-code');
        var vfittedsheetDN = eletoChange.attr('data-icolor-name');
        var vfittedsheetCID = cammiejs.getColorClass(eletoChange.find('.ssit_fittedsheet'));


        eletoChange = $('li[data-ele="rgt_flat-sheet"]');
        var vflatsheetC = eletoChange.find('#product-svg path').attr('fill');
        var vflatsheetN = eletoChange.find('.color-name').html();
        var vflatsheetDC = eletoChange.attr('data-icolor-code');
        var vflatsheetDN = eletoChange.attr('data-icolor-name');
        var vflatsheetCID = cammiejs.getColorClass(eletoChange.find('.ssit_flatsheet'));

        eletoChange = $('li[data-ele="rgt_pillowcase"]');
        var vpillowcaseC = eletoChange.find('#product-svg path').attr('fill');
        var vpillowcaseN = eletoChange.find('.color-name').html();
        var vpillowcaseDC = eletoChange.attr('data-icolor-code');
        var vpillowcaseDN = eletoChange.attr('data-icolor-name');
        var vpillowcaseCID = cammiejs.getColorClass(eletoChange.find('.ssit_pillow'));


        eletoChange = $('li[data-ele="rgt_sham"]');
       if(eletoChange.length > 0)
       {
        var vshamC = eletoChange.find('#product-svg path').attr('fill');
        var vshamN = eletoChange.find('.color-name').html();
        var vshamDC = eletoChange.attr('data-icolor-code');
        var vshamDN = eletoChange.attr('data-icolor-name');
        var vshamCID = cammiejs.getColorClass(eletoChange.find('.ssit_sham'));
       }

        eletoChange = $('li[data-ele="rgt_duvet-cover"]');
       if(eletoChange.length > 0)
       {
        var vduvetcoverC = eletoChange.find('#product-svg path').attr('fill');
        var vduvetcoverN = eletoChange.find('.color-name').html();
        var vduvetcoverDC = eletoChange.attr('data-icolor-code');
        var vduvetcoverDN = eletoChange.attr('data-icolor-name');
        var vduvetcoverCID = cammiejs.getColorClass(eletoChange.find('.ssit_duvetcover'));
       }

        var vinspirecentC = '';
        if ($('#color-inspiration-cont').length > 0)
            vinspirecentC = $('#color-inspiration-cont').prop('outerHTML');


        var vURL = vcurrtele.attr('data-url');
       if($('#hcustinspid').val().length >0 && $('#hpathurl').val().length >0 && $('#hpathurl').val()=="cust")
       {
         vURL = vURL +"?id=" + $('#hcustinspid').val();
       }
        fetch(vURL).then((response) => response.text())
            .then((responseText) => {


                const html = new DOMParser().parseFromString(responseText, 'text/html');
                $('title').html($(html).find('title').html());
                cammiejs.updatereplaceurl($('head title').text(), vURL);
                var vlefttab = $(".psrc_aminm_card").css("left");
                var vTabData = JSON.parse(cammiejs.getlatesttabelem());
                var vindex = $('.producths li.active').index();
                var vinnerindex = $('.psrc_tab_menu .tablinks.active').index();
                var vloadinnerpage = $('.producths li.active').length > 0;

              
                //$('.shopify-section').html($(html).find('.shopify-section').html());
                $('.producths').html($(html).find('.producths').html());
                $('.pss_left_card').html($(html).find('.pss_left_card').html());
                //$('.pss_right_card').html($(html).find('.pss_right_card').html());
                /*$('.pss_right_card .psrc_list_menu li').each(function( index ) {
                    $(this).attr('onclick',$(html).find('.pss_right_card .psrc_list_menu li[data-ele='+ $(this).attr("data-ele") +']').attr('onclick'));
                });*/
                $('.fixed_footer').html($(html).find('.fixed_footer').html());

                eletoChange = $('.svg_fitted-sheet');
                eletoChange.find('path').attr('fill', vfittedsheetC);
                $('li[data-ele="rgt_fitted-sheet"]').attr('data-icolor-code', vfittedsheetDC).attr('data-icolor-name', vfittedsheetDN).find('#product-svg path').attr('fill', vfittedsheetC).find('.color-name').html(vfittedsheetN);
                $('li[data-ele="rgt_fitted-sheet"]').find('.color-name').html(vfittedsheetN);
                var velems = $('.pss_left_card .ssit_fittedsheet,.pss_left_card .hsit_fittedsheet,.pss_left_card .htit_fittedsheet,.pss_left_card .stit_fittedsheet,.producths .hsit_fittedsheet,.producths .ssit_fittedsheet');
                cammiejs.removeColorClass(velems);
                velems.addClass(vfittedsheetCID);

                eletoChange = $('.svg_flat-sheet');
                eletoChange.find('path').attr('fill', vflatsheetC);
                $('li[data-ele="rgt_flat-sheet"]').attr('data-icolor-code', vflatsheetDC).attr('data-icolor-name', vflatsheetDN).find('#product-svg path').attr('fill', vflatsheetC).find('.color-name').html(vflatsheetN);
                $('li[data-ele="rgt_flat-sheet"]').find('.color-name').html(vflatsheetN);
                var velems = $('.pss_left_card .ssit_flatsheet,.pss_left_card .hsit_flatsheet,.pss_left_card .htit_flatsheet,.pss_left_card .stit_flatsheet,.producths .hsit_flatsheet,.producths .ssit_flatsheet');
                cammiejs.removeColorClass(velems);
                velems.addClass(vflatsheetCID);

                eletoChange = $('.svg_pillowcase');
                eletoChange.find('path').attr('fill', vpillowcaseC);
                $('li[data-ele="rgt_pillowcase"]').attr('data-icolor-code', vpillowcaseDC).attr('data-icolor-name', vpillowcaseDN).find('#product-svg path').attr('fill', vpillowcaseC).find('.color-name').html(vpillowcaseN);
                $('li[data-ele="rgt_pillowcase"]').find('.color-name').html(vpillowcaseN);
                var velems = $('.pss_left_card .ssit_pillow,.pss_left_card .hsit_pillow,.pss_left_card .htit_pillow,.pss_left_card .stit_pillow,.producths .hsit_pillow,.producths .ssit_pillow');
                cammiejs.removeColorClass(velems);
                velems.addClass(vpillowcaseCID);

                eletoChange = $('.svg_sham');
                eletoChange.find('path').attr('fill', vshamC);
                $('li[data-ele="rgt_sham"]').attr('data-icolor-code', vshamDC).attr('data-icolor-name', vshamDN).find('#product-svg path').attr('fill', vshamC).find('.color-name').html(vshamN);
                $('li[data-ele="rgt_sham"]').find('.color-name').html(vshamN);
                var velems = $('.pss_left_card .ssit_sham,.pss_left_card .hsit_sham,.pss_left_card .htit_sham,.pss_left_card .stit_sham,.producths .hsit_sham,.producths .ssit_sham');
                if(velems.length >0)
                {
                cammiejs.removeColorClass(velems);
                velems.addClass(vshamCID);
                }

                eletoChange = $('.svg_duvet-cover');
                eletoChange.find('path').attr('fill', vduvetcoverC);
                $('li[data-ele="rgt_duvet-cover"]').attr('data-icolor-code', vduvetcoverDC).attr('data-icolor-name', vduvetcoverDN).find('#product-svg path').attr('fill', vduvetcoverC).find('.color-name').html(vduvetcoverN);
                $('li[data-ele="rgt_duvet-cover"]').find('.color-name').html(vduvetcoverN);
                var velems = $('.pss_left_card .ssit_duvetcover,.pss_left_card .hsit_duvetcover,.pss_left_card .htit_duvetcover,.pss_left_card .stit_duvetcover,.producths .hsit_duvetcover,.producths .ssit_duvetcover');
                if(velems.length >0)
                {
                cammiejs.removeColorClass(velems);
                velems.addClass(vduvetcoverCID);
                }

                if (vinspirecentC.length > 0) {
                    $('#color-inspiration-cont').remove();
                    $('#color-recent-cont').before(vinspirecentC);
                }
                cammiejs.changemapname();

                if (vloadinnerpage) {
                  configtabclick = 0; 
                    $('.producths li').eq(vindex).click();
                    $('.psrc_tab_menu .tablinks').eq(vinnerindex).click();
                }
            });
    },
    updatereplaceurl: function(title, url) {
        const nextState = {
            additionalInformation: 'Updated the URL with JS'
        };
        window.history.replaceState(nextState, title, url);
    },
    updateurl: function(title, url) {
        const nextState = {
            additionalInformation: 'Updated the URL with JS'
        };
        window.history.pushState(nextState, title, url);
    },
    getPDPPage: function(obj, type) {
        var vURL = "";

        vURL = $(obj).attr('data-url');


        var vcustomhighlight = 0;
        var vlstacttabelem = "";
        var vvTabData = JSON.parse(cammiejs.getlatesttabelem());
        if (Object.keys(vvTabData).length > 0) {
            vlstacttabelem = vvTabData['lasttabeleclicked'];
        }
        if ($('#hurltype').val() == "3") {
            vURL = vURL + '/' + $('#hpathurl').val();
        } else if (vlstacttabelem == "color-group-btn") {
            var vname = $('#color-group-wrapper .pscl_listed li[data-id="' + vvTabData['colorgroup'] + '"]').attr('data-colorurl');
            vURL = vURL + '/' + vname;
        } else if (vlstacttabelem == "color-all-btn") {
            var vname = $('#color-all-wrapper .pscl_listed li[data-id="' + vvTabData['colorall'] + '"]').attr('data-colorurl');
            vURL = vURL + '/' + vname;
        } else if (vlstacttabelem == "color-inspiration-btn") {
            vURL = vURL + '/' + vvTabData['inspi'];
        } else if (vlstacttabelem == "color-yourdesign-btn") {
            vURL = vURL + '/' + 'cust?id=' + vvTabData['yourdesign'];
        }
        else if($('#hcustinspid').val().length >0) {
           vURL = vURL + '/' + 'cust?id=' + $('#hcustinspid').val();
        }

        cammiejs.getPDPPageData(vURL);


    },
    getPDPPageData: function(vURL) {

        fetch(vURL).then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                var vTabData = JSON.parse(cammiejs.getlatesttabelem());
                $('title').html($(html).find('title').html());
                cammiejs.updatereplaceurl($('title').text(), vURL);
                $('.pss_left_card').html($(html).find('.pss_left_card').html());
                $('.pss_right_card').html($(html).find('.pss_right_card').html());
                $('.may_like_card').html($(html).find('.may_like_card').html());
                $('.fixed_footer').html($(html).find('.fixed_footer').html());
               
                $('#reviews').html($(html).find('#reviews').html());
            
             
                $('#mixmatchurl,.mixmatchurl').attr('href',vURL.replace('/collections/','/pages/'));

              
                cammiejs.loadAccordion();
                cammiejs.loadpdppage();
                cammiejs.loadyourdesign();
                cammiejs.loadcarousel();
                cammiejs.loadcarouselv1();
                cammiejs.showhideprevnext();
                if(vURL.indexOf("cust?id=") > -1)
                {
                  cammiejs.loadurldesign();
                }
                /*if(vcustomhighlight == 2)
                 {
                   $('#color-group-btn').click();
                 }
                else if(vcustomhighlight == 3)
                 {
                   $('#color-all-btn').click();
                 }*/

                if (Object.keys(vTabData).length > 0) {
                    if (vTabData.hasOwnProperty('inspi') && vTabData.hasOwnProperty('lasttabeleclicked') && vTabData['lasttabeleclicked'] == 'color-inspiration-btn') {
                        cammiejs.removeallactiveeleintab();
                        $('#color-inspiration-wrapper .pscl_color_plt li a[data-ikey="' + vTabData['inspi'] + '"]').addClass('active');
                    }
                    if (vTabData.hasOwnProperty('colorgroup') && vTabData.hasOwnProperty('lasttabeleclicked') && vTabData['lasttabeleclicked'] == 'color-group-btn') {
                        $('#color-group-wrapper .pscl_listed li a.active').removeClass('active');
                        $('#color-group-wrapper .pscl_listed li[data-id="' + vTabData['colorgroup'] + '"]').find('a').addClass('active');
                    }
                    if (vTabData.hasOwnProperty('colorall') && vTabData.hasOwnProperty('lasttabeleclicked') && vTabData['lasttabeleclicked'] == 'color-all-btn') {
                        $('#color-all-wrapper .pscl_listed li a.active').removeClass('active');
                        $('#color-all-wrapper .pscl_listed li[data-id="' + vTabData['colorall'] + '"]').find('a').addClass('active');
                    }
                    if (vTabData.hasOwnProperty('yourdesign') && vTabData.hasOwnProperty('lasttabeleclicked') && vTabData['lasttabeleclicked'] == 'color-yourdesign-btn') {
                        $('#color-yourdesign-wrapper .pscl_color_plt li a.active').removeClass('active');
                        $('#color-yourdesign-wrapper .pscl_color_plt li a[data-id="' + vTabData['yourdesign'] + '"]').addClass('active');
                    }
                    if (vTabData.hasOwnProperty('lasttabactive')) {
                        $('#' + vTabData['lasttabactive']).click();
                    }
                    if (vTabData.hasOwnProperty('lasttabeleclicked') && vTabData['lasttabeleclicked'] == 'color-yourdesign-btn') {
                        var obj = $('#color-yourdesign-wrapper .pscl_color_plt li a[data-id="' + vTabData['yourdesign'] + '"]');
                        var attr = $(obj).attr('data-fitted-sheet-code');
                        if (typeof attr !== 'undefined' && attr !== false) {
                            var eletoChange = $('.pss_left_card .svg_fitted-sheet');
                            eletoChange.find('path').attr('fill', attr);
                            $('.clr_fitted-sheet').html($('.pscl_listed li[data-colorcode="' + attr + '"]').attr('data-name'));
                            $('.clr_fitted-sheet').closest('li').find('.accl_color_plt span').css('background', attr);
                        }
                        attr = $(obj).attr('data-flat-sheet-code');
                        if (typeof attr !== 'undefined' && attr !== false) {
                            var eletoChange = $('.pss_left_card .svg_flat-sheet');
                            eletoChange.find('path').attr('fill', attr);
                            $('.clr_flat-sheet').html($('.pscl_listed li[data-colorcode="' + attr + '"]').attr('data-name'));
                            $('.clr_flat-sheet').closest('li').find('.accl_color_plt span').css('background', attr);
                        }
                        attr = $(obj).attr('data-pillowcase-code');
                        if (typeof attr !== 'undefined' && attr !== false) {
                            var eletoChange = $('.pss_left_card .svg_pillowcase');
                            eletoChange.find('path').attr('fill', attr);
                            $('.clr_pillowcase').html($('.pscl_listed li[data-colorcode="' + attr + '"]').attr('data-name'));
                            $('.clr_pillowcase').closest('li').find('.accl_color_plt span').css('background', attr);
                        }
                        attr = $(obj).attr('data-sham-code');
                        if (typeof attr !== 'undefined' && attr !== false) {
                            var eletoChange = $('.pss_left_card .svg_sham');
                            eletoChange.find('path').attr('fill', attr);
                            $('.clr_sham').html($('.pscl_listed li[data-colorcode="' + attr + '"]').attr('data-name'));
                            $('.clr_sham').closest('li').find('.accl_color_plt span').css('background', attr);
                        }
                        attr = $(obj).attr('data-duvet-cover-code');
                        if (typeof attr !== 'undefined' && attr !== false) {
                            var eletoChange = $('.pss_left_card .svg_duvet-cover');
                            eletoChange.find('path').attr('fill', attr);
                            $('.clr_duvet-cover').html($('.pscl_listed li[data-colorcode="' + attr + '"]').attr('data-name'));
                            $('.clr_duvet-cover').closest('li').find('.accl_color_plt span').css('background', attr);
                        }
                        $('.yourdesign-name').html($(obj).attr('data-name'));
                        cammiejs.removeextraimages();
                    }
                }
            });

    },
    blockerinit: function() {

        window.onload = cammiejs.resetTimer;
        window.onmousemove = cammiejs.resetTimer;
        window.onmousedown = cammiejs.resetTimer; // catches touchscreen presses as well      
        window.ontouchstart = cammiejs.resetTimer; // catches touchscreen swipes as well      
        window.ontouchmove = cammiejs.resetTimer; // required by some devices 
        window.onclick = cammiejs.resetTimer; // catches touchpad clicks as well
        window.onkeydown = cammiejs.resetTimer;
        window.addEventListener('scroll', cammiejs.resetTimer, true); // improved; see comments
    },
    resetTimer: function() {
        clearTimeout(vTimer);
        vTimer = setTimeout(cammiejs.blockerPopup, 20000); // time is in milliseconds
    },
    blockerPopupClose: function() {
        $('#logoPopup').css('display', 'none');
        cammiejs.resetTimer()
    },
    blockerPopup: function() {

        //$('#logoPopup').css('display','flex');
    },
    imgPopup: function(url, type) {
        cammiejs.popupOpen("Size Guide", "<img src=\"" + url + "\" />");
    },
    popupOpen: function(heading, content) {

        // $('#commonPopup h2').html(heading).hide();
        //$('#commonPopup .popup_wrapper').html(content);  
        $('#commonPopup').css('display', 'flex');
    },
    popupClose: function() {
        $('#commonPopup').css('display', 'none');
    },
    setCookiev1: function(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    setCookie: function(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        var vValue = cvalue + ',' + cammiejs.getCookie(cname).replace(',' + cvalue + ',', ",");

        const regex = /,,/ig;
        vValue = vValue.replaceAll(regex, ',');

        if (!vValue.startsWith(",")) {
            vValue = "," + vValue;
        }
        document.cookie = cname + "=" + vValue + ";" + expires + ";path=/";
    },
    getCookie: function(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    showStickyBottom: function() {
        $('.sticky_cont').show();
    },
    hideStickyBottom: function() {
        if ($('html').width() < vMobilesize) {
            $('.sticky_cont').hide();
        }
    },
    loadRecent: function() {
        $('.slide-show.active').each(function(index) {
            var vCokname = cammiejs.cookiename;
            var vCokVal = cammiejs.getCookie(vCokname) + "";
            $('#color-recent-cont ul').html('');
            $('.recentcolorheading').hide();
            if (vCokVal.length > 0) {
                vCokValarr = vCokVal.split(",");
                $.each(vCokValarr, function(index, value) {
                    if (value.length > 0) {
                        $('#color-recent-cont ul').append($('.pscl_listed li[data-id="' + value + '"]:first').prop("outerHTML"));
                    }
                });
                $('#color-recent-count').html('(' + $('#color-recent-cont ul li').length + ')');
                $('.recentcolorheading').show();
            }
            if ($('#color-inspiration-cont').length > 0) {
                var vclrinspiul = $('#color-inspiration-cont ul');
                vclrinspiul.html('');
                vclrinspiul.append($('#color-all-cont .pscl_listed li[data-colorcode="' + $('#color-inspiration-cont').attr('data-fittedsheet') + '"]').prop('outerHTML'));
                if ($('#color-inspiration-cont .pscl_listed li[data-colorcode="' + $('#color-inspiration-cont').attr('data-flatsheet') + '"]').length == 0)
                    vclrinspiul.append($('#color-all-cont .pscl_listed li[data-colorcode="' + $('#color-inspiration-cont').attr('data-flatsheet') + '"]').prop('outerHTML'));
                if ($('#color-inspiration-cont .pscl_listed li[data-colorcode="' + $('#color-inspiration-cont').attr('data-pillow') + '"]').length == 0)
                    vclrinspiul.append($('#color-all-cont .pscl_listed li[data-colorcode="' + $('#color-inspiration-cont').attr('data-pillow') + '"]').prop('outerHTML'));

                if ($('#hbundletype').val() == "1") {
                    if ($('#color-inspiration-cont .pscl_listed li[data-colorcode="' + $('#color-inspiration-cont').attr('data-duvetcover') + '"]').length == 0)
                        vclrinspiul.append($('#color-all-cont .pscl_listed li[data-colorcode="' + $('#color-inspiration-cont').attr('data-duvetcover') + '"]').prop('outerHTML'));
                    if ($('#color-inspiration-cont .pscl_listed li[data-colorcode="' + $('#color-inspiration-cont').attr('data-sham') + '"]').length == 0)
                        vclrinspiul.append($('#color-all-cont .pscl_listed li[data-colorcode="' + $('#color-inspiration-cont').attr('data-sham') + '"]').prop('outerHTML'));
                }
            }
            $('#color-recent-count').html('(' + ($('#color-recent-cont ul li').length + $('#color-inspiration-cont ul li').length) + ')');
        });
    },
    openTab: function(obj, elemtoShow) {
        $('.tablinks.active').removeClass('active');
        $('.tabcontent').removeClass('hide').hide();
        $(obj).addClass('active');
        $('#' + elemtoShow).show();
        $('#' + elemtoShow).closest('.pstm_color_list')[0].scrollTop = 0;
        cammiejs.updatelatesttabprop("lasttabactive", $(obj).attr('id'));
    },
    backColorTab: function() {
        $('.slide-show.active').removeClass('active');
        $(".psrc_aminm_card").animate({
            "left": "0px"
        }, "slow", function() {
            //cammiejs.showStickyBottom();
            $(".psrc_tab_menu").removeClass('active');
        });
        // $('.pslc_done_btn').removeClass('psd_active');
    },
    cancelColorTab: function(obj, type) {
        $(obj).closest('.tabcontent').find('.color-name').html($('#color-old-name').val());
        var eletoChange = $('.' + $('.slide-show.active').attr('data-ele').replace("rgt", "svg"));
        //$('.slide-show.active path').attr('fill',$('#color-old-code').val());
        // eletoChange.find('path').attr('fill',$('#color-old-code').val());  
        if (type == "1") {
            cammiejs.backColorTab();
            //$('.pscl_inner_card:visible')[0].scrollTop = 0;
            //cammiejs.hideColorTab();
            //$("#tab_heading").show();
            // $('.pstcl_fix_height').removeClass('pstcl_fix_height');
        }
    },
    hideColorTab: function() {

        $('.slide-show.active').removeClass('active');

        $(".psrc_aminm_card").animate({
            "left": "0px"
        }, "slow", function() {
            $(".psrc_tab_menu").removeClass('active');
        });

       
    },
    yourcurrentdesign: function() {
        $('#color-yourcurrentdesign-cont ul').html('');
        $('.side_svg_view svg').each(function(index) {
            if ($('#color-yourcurrentdesign-cont ul li[data-colorcode="' + $(this).find("path").attr("fill") + '"]').length == 0)
                $('#color-yourcurrentdesign-cont ul').append($('.pscl_listed li[data-colorcode="' + $(this).find("path").attr("fill") + '"]:first').prop("outerHTML"));

        });
        $('#color-yourcurrentdesign-count').html('(' + $('#color-yourcurrentdesign-cont ul li').length + ')');
    },
    showColorTab: function(obj, url) {
        $('.slide-show').removeClass('active');
        $(obj).addClass('active');
        var vcatext = ($('.pss_header_card ul li.active').index() + 1) + '/' + $('.pss_header_card ul li').length;
        if ($('.pss_header_card ul li.active').index() + 1 == 1) {
            $('.previousprod').addClass("inactive");
        } else {
            $('.previousprod').removeClass('inactive'); 
          $('.previousprod span').html($(obj).prev().find('h4 label').text());
        }
        if ($('.pss_header_card ul li.active').index() + 1 == $('.pss_header_card ul li').length) {
            $('.nextprod').addClass("inactive");
        } else {
            $('.nextprod').removeClass('inactive');
           $('.nextprod span').html($(obj).next().find('h4 label').text());
        }
   
        $('.psrc_header_card h6').text(vcatext);

      if(configtabclick ==0)
      {
        var eletoChange = $('.' + $(obj).attr('data-ele').replace("rgt", "svg"));
       $('.blink-soft').removeClass('blink-soft');
       var vpathobj = $('.pss_left_card .'+ $(obj).attr('data-ele').replace("rgt", "svg")+ ' path');
        vpathobj.addClass('blink-soft');
       setTimeout(function() {
          vpathobj.removeClass('blink-soft');
        }, 1500);
      }
configtabclick =0;
      
        var vcode = eletoChange.find('path').attr('fill');
        var vname = $(obj).find('.color-name').html();
        var vheading = $(obj).attr('data-name');
        var vURL = `/pages/ajaxgetcolor/` + url;
        fetch(vURL).then((response) => response.text())
            .then((responseText) => {
               
                const html = new DOMParser().parseFromString(responseText, 'text/html'); 
               if($('#color-group-cont').children().length >0)
              {
                  $(html).find('#color-group .pscl_listed li').attr("data-exist","0");
                  var vcolorgroup = $(html).find('#color-group .pscl_listed li');
                  $('.pstm_color_list .pscl_listed li').attr("data-exist","0");
                  vcolorgroup.each(function(){
                    var dattr = $(this).data(); 
                    var vexstingele = $('.pstm_color_list .pscl_listed li[data-id="'+$(this).data('id')+'"]');
                    if(vexstingele.length == 0)
                    {
                      var ulelem = $(this).closest('.pscl_listed');
                      var vhtml = $(this).closest('.pscl_listed').prev('h5').prop('outerHTML') + $(this).closest('.pscl_listed').prop('outerHTML');
                      $('#color-group-cont').eq($(this).closest('.pscl_listed').prev('h5').index()).prepend($(vhtml).hide().delay(500).slideDown("slow"));
                      vexstingele = $('.pstm_color_list .pscl_listed li[data-id="'+$(this).data('id')+'"]');
                    }
                    $(this).attr("data-exist","1");
                    vexstingele.attr("data-exist","1");
                    vexstingele.removeAttr('data-fitted-sheet-vid');
                    vexstingele.removeAttr('data-flat-sheet-vid');
                    vexstingele.removeAttr('data-pillowcase-vid');
                    vexstingele.removeAttr('data-sham-vid');
                    vexstingele.removeAttr('data-duvet-cover-vid');

                    if(dattr.hasOwnProperty('fittedSheetVid'))
                    {
                      vexstingele.attr("data-fitted-sheet-vid", $(this).attr("data-fitted-sheet-vid"));
                    }
                    if(dattr.hasOwnProperty('flatSheetVid'))
                    {
                      vexstingele.attr("data-flat-sheet-vid", $(this).attr("data-flat-sheet-vid"));
                    }
                    if(dattr.hasOwnProperty('pillowcaseVid'))
                    {
                      vexstingele.attr("data-pillowcase-vid", $(this).attr("data-pillowcase-vid"));
                    }
                    if(dattr.hasOwnProperty('shamVid'))
                    {
                      vexstingele.attr("data-sham-vid", $(this).attr("data-sham-vid"));
                    }
                    if(dattr.hasOwnProperty('duvetCoverVid'))
                    {
                      vexstingele.attr("data-duvet-cover-vid", $(this).attr("data-duvet-cover-vid"));
                    }                    
                  });
                // $('.pstm_color_list .pscl_listed li[data-exist="0"]').remove();
                 $('.pscl_listed').each(function(){
                   if($(this).children().length == $(this).find('li[data-exist="0"]').length)
                   {
                     $(this).prev().slideUp("slow", function() {
                         $(this).remove();
                     });
                     $(this).slideUp("slow", function() {
                         $(this).remove();
                     });
                   }
                 });                
              }
              else
               {
                  document.getElementById('color-group-cont').innerHTML = html.getElementById('color-group').innerHTML;
                  $('#color-group-count').html('(' + $('#color-group-cont h5').length + ')');
              }
              
                if ($('#color-all-count').length > 0) {
                    document.getElementById('color-all-cont').innerHTML = html.getElementById('color-all').innerHTML;
                    $('#color-all-count').html('(' + $('#color-all-cont li').length + ')');
                }
                $('.heading').html(vheading);


                $('.pscl_listed .active').removeClass('active');
                //$('.pscl_listed li[data-colorcode="' + vcode + '"]').find('a').addClass('active');
              $('.pscl_listed li[data-colorcode="' + vcode + '"]').click();
                $('.pstm_header_card .color-name,h1 .color-name').html(vname);
                $('.psrc_list_menu').addClass('pslm_no_scroll');
 
                 function vtfun(){
                  //cammiejs.hideStickyBottom();
                   $('.psrc_list_menu').removeClass('pslm_no_scroll');
                    $('.tablinks.active').trigger('click');
                    $(".psrc_tab_menu").addClass('active');
                    cammiejs.loadRecent();
                    cammiejs.yourcurrentdesign();      
                }
               vtfun();  
                //$('.pslc_done_btn').addClass('psd_active');
                /* $(".psrc_tab_menu").show( "slow", function() {
      
      $('.tablinks:first').trigger('click');
        cammiejs.loadRecent();
  });
      $(".psrc_list_menu").hide(); */
                // $('#color-old-code').val(vcode);
                // $('#color-old-name').val(vname);
                // $('#color-new-name').val(vname);
                //$('#color-new-code').val(vcode);
            });
    },
    naviViewIndividual: function(type) {

        if (type == '1') {
            $('.pslc_fixed_card a.active').prev('a').trigger('click');

        } else if (type == '2') {
            $('.pslc_fixed_card a.active').next('a').trigger('click');


        }
    },
     loadcarouselv1: function() {
       
     
        $(".commoncarousel").each(function(index) {
            var vitemcnt = 3.4;
            var vpageDots = true;
            if (matchMedia('screen and (max-width: 480px)').matches) {
                vitemcnt = 1.2;
                vpageDots = true;
            } else if (matchMedia('screen and (max-width: 1030px)').matches) {
                vitemcnt = 2.6;
            }
            var vprevNextButtons = true;
            $(this).removeClass('carouselftalign');
            if ($(this).find('.carousel-cell').length <= Number($(this).attr('data-showele'))) {
                vprevNextButtons = false;
                $(this).addClass('carouselftalign');
            }
            var vGroup = false;
            if ($(this).attr('data-group') == 'true') {
                vGroup = true;
            }
          var $ele = $(this);
           $ele.on( 'ready.flickity', function() {      
               if($ele.find('.flickity-prev-next-button.previous').prop('disabled') && $ele.find('.flickity-prev-next-button.next').prop('disabled'))
               {
                 $ele.addClass('slider_left_align');
               }
            });
            if ($(this).attr('data-dots') == 'false') {
                vpageDots = false;
            }
            var $carousel = $ele.flickity({
                "contain": true,
                "pageDots": vpageDots,
                "groupCells": vGroup,
                "draggable": true,
                "prevNextButtons": vprevNextButtons,
                "percentPosition": true,
                "cellAlign": "center",
               "imagesLoaded": true
            });
          
            var vRange = false;
            var vRangeele;
            if ($(this).hasClass('shopcarousel')) {
                vRange = true;
                vRangeele = $('#shopcarouselrange');
                vRangeele.attr('max', $(this).find('.flickity-page-dots li').length - 1);
            } else if ($(this).hasClass('getinspiredcarousel')) {
                vRange = true;
                vRangeele = $('#getinspiredcarouselrange');
                vRangeele.attr('max', $(this).find('.flickity-page-dots li').length - 1);
            } else if ($(this).hasClass('youmayalsocarousel')) {
                vRange = true;
                vRangeele = $('#youmayalsorange');
                vRangeele.attr('max', $(this).find('.flickity-page-dots li').length - 1);
            } else if ($(this).hasClass('otherprodcarousel')) {
                vRange = true;
                vRangeele = $('#otherprodrange');
                vRangeele.attr('max', $(this).find('.flickity-page-dots li').length - 1);
            }
            if (vRange) {
                vRangeele.on('input', function() {
                    var newval = $(this).val();
                    $carousel.flickity('select', newval);
                });
                $carousel.on('select.flickity', function() {
                    vRangeele.val($carousel.data('flickity').selectedIndex);
                });
            } 

        
        });
        /* $( ".alc_slider" ).each(function( index ) {

         $(this).flickity({ "contain": true, "pageDots": vpageDots,"groupCells": false,"groupCells": vitemcnt,"draggable":true });

        
      var $slickEl = $(this);
  
     
      var vno = parseFloat($slickEl.attr('data-showno'));
      var vno1030 = parseFloat($slickEl.attr('data-showno1030'));
      var vno480 = parseFloat($slickEl.attr('data-showno480'));
       var vprev= $('#'+ $slickEl.attr('data-prev'));
        var vnext= $('#'+ $slickEl.attr('data-next'));

var vresponsive = [
                {
                breakpoint: 1030,
                settings: {
                    arrows: false,
                    centerMode: false,
                    centerPadding: '40px',
                    slidesToShow: vno1030
                }
                },
                {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: false,
                    centerPadding: '40px',
                    slidesToShow: vno480
                }
                }
            ];
        var vno1600 =$slickEl.attr('data-showno1600')
        if(vno1600 != "undefined" && vno1600 != undefined)
        {
          var jsobj = {
                breakpoint: 1600,
                settings: {
                   slidesToShow: parseFloat(vno1600)
                }
            };
vresponsive.push(jsobj);
        }
        var vno1380 =$slickEl.attr('data-showno1380')
        if(vno1380 != "undefined" && vno1380 != undefined)
        {
          var jsobj = {
                breakpoint: 1380,
                settings: {
                   slidesToShow: parseFloat(vno1380)
                }
            };
          vresponsive.push(jsobj); 
        }
      if($slickEl.hasClass('slick-initialized')) {
        $slickEl.slick('unslick');
      }
      $slickEl.slick({
        draggable:true,
        swipeToSlide:true,
        swipe:true,
        touchMove:true,
        centerMode: false,
        slidesToShow: vno,
        focusOnSelect: false,
        dots: false,
        infinite: false,
        nextArrow: vnext,
        prevArrow :vprev,
            responsive: vresponsive
       });
     
     }); */
    },
    loadcarousel: function() {
        document.querySelectorAll('.scroll-toggle').forEach(el => {
            const scrollToggle = new ScrollToggle(el);
            scrollToggle.init();
        });
    },
    showViewIndividual: function(obj) {
        $('.svg_view_img').hide();
        $('.pslc_fixed_card a.active').removeClass('active');
        $(obj).addClass('active');

        if ($('.' + $(obj).attr('data-view')).hasClass('bigimage') || $('.' + $(obj).attr('data-view')).hasClass('smallimage')) {
            $('.bigimage img').attr('src', $('.pscl_listed li a.active').find('img').attr('src').replace('.png', '-big.png').replace('.webp', '-big.webp'));
            $('.smallimage img').attr('src', $('.pscl_listed li a.active').find('img').attr('src'));
        }

        $('.' + $(obj).attr('data-view')).show();
        if ($('.pslc_fixed_card a.active').prev('a').length == 0) {
            $('.psic_left_arrow').removeClass('psa_active');
        } else {
            $('.psic_left_arrow').addClass('psa_active');
        }
        if ($('.pslc_fixed_card a.active').next('a').length == 0) {
            $('.psic_right_arrow').removeClass('psa_active');
        } else {

            $('.psic_right_arrow').addClass('psa_active');
        }
    },
    showViewNav: function(type) {
        if (type == "1") {
            $('.gallthumb.active').prev('a.gallthumb').click();
        } else if (type == "2") {
            $('.gallthumb.active').next('a.gallthumb').click();
        }
    },
    showView: function(obj) {
        $('.gallthumb').removeClass('active');
        $(obj).addClass('active');
        $('.gallimg').hide();
        $('.' + $(obj).attr('data-view')).show();
        if ($(obj).prev('a.gallthumb').length > 0) {
            $('.psic_left_arrow').addClass('psa_active');
        } else {
            $('.psic_left_arrow').removeClass('psa_active');
        }
        if ($(obj).next('a.gallthumb').length > 0) {
            $('.psic_right_arrow').addClass('psa_active');
        } else {
            $('.psic_right_arrow').removeClass('psa_active');
        }
    },
    chooseColorTab: function(obj) {
        cammiejs.setCookie(cammiejs.cookiename, $('#color-new-code').val(), 1);
        //$('.slide-show.active').find('.color-name').html($('#color-new-name').val());
        //$('.pscl_inner_card:visible')[0].scrollTop = 0;
        cammiejs.hideColorTab();
        //$("#tab_heading").show();
        $('.pstcl_fix_height').removeClass('pstcl_fix_height');
    },
   loadurldesign: function() {
            var vcustid = cammiejs.getquerystring('id');  
            var vnewKeyarray = vcustid.match(/.{1,2}/g);
            for (let index = 0; index < vnewKeyarray.length; ++index) {
               vnewKeyarray[index] = Number(vnewKeyarray[index]);
            }
            var eletoChange = $('.pss_left_card .svg_fitted-sheet');
            eletoChange.find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[0]));
            var velems = $('.pss_left_card .ssit_fittedsheet,.pss_left_card .hsit_fittedsheet,.pss_left_card .htit_fittedsheet,.pss_left_card .stit_fittedsheet');
            cammiejs.removeColorClass(velems);
            velems.addClass("color_"+vnewKeyarray[0]);
          
            var eletoChange = $('.pss_left_card .svg_flat-sheet');
            eletoChange.find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[1]));
            var velems = $('.pss_left_card .ssit_flatsheet,.pss_left_card .hsit_flatsheet,.pss_left_card .htit_flatsheet,.pss_left_card .stit_flatsheet');
            cammiejs.removeColorClass(velems);
            velems.addClass("color_"+vnewKeyarray[1]);            
             
            var eletoChange = $('.pss_left_card .svg_pillowcase');
            eletoChange.find('path').attr('fill',cammiejs.getcolorcodebyid(vnewKeyarray[2]));
            var velems = $('.pss_left_card .ssit_pillow,.pss_left_card .hsit_pillow,.pss_left_card .htit_pillow,.pss_left_card .stit_pillow');
            cammiejs.removeColorClass(velems);
           velems.addClass("color_"+vnewKeyarray[2]);  
             
            if(vnewKeyarray.length > 3)
            {
              var eletoChange = $('.pss_left_card .svg_sham');
              eletoChange.find('path').attr('fill',cammiejs.getcolorcodebyid(vnewKeyarray[3]));
              var velems = $('.pss_left_card .ssit_sham,.pss_left_card .hsit_sham,.pss_left_card .htit_sham,.pss_left_card .stit_sham');
              if(velems.length >0 )
              {
                  cammiejs.removeColorClass(velems);
                  velems.addClass("color_"+vnewKeyarray[3]);  
              } 
            }
            if(vnewKeyarray.length > 3)
            {
               
                var eletoChange = $('.pss_left_card .svg_duvet-cover');
                eletoChange.find('path').attr('fill', cammiejs.getcolorcodebyid(vnewKeyarray[4]));
                var velems = $('.pss_left_card .ssit_duvetcover,.pss_left_card .hsit_duvetcover,.pss_left_card .htit_duvetcover,.pss_left_card .stit_duvetcover');
              if(velems.length >0 )
              {
                  cammiejs.removeColorClass(velems);
                  velems.addClass("color_"+vnewKeyarray[4]); 
              } 
            }
            $('#hcustinspid').val(vcustid); 
      
        cammiejs.loadpdppage();
    },
    changeyourdesign: function(obj, type) {
        cammiejs.removeallactiveeleintab();
        cammiejs.updatelatesttabelem("yourdesign", $(obj).attr('data-id'));
        $(obj).addClass('active');
    $('.urltypekey').text("Your design");
      $('.urltypevalue').html('<span>' + $(obj).attr('data-name') + '</span>');
       $('.act_color_plt').hide();
      $('.descriptioncolors').addClass('hide');
        if (type == "2") {

            var attr = $(obj).attr('data-fitted-sheet-code');
            if (typeof attr !== 'undefined' && attr !== false) {
                var eletoChange = $('.pss_left_card .svg_fitted-sheet');
                eletoChange.find('path').attr('fill', attr);
                var velems = $('.pss_left_card .ssit_fittedsheet,.pss_left_card .hsit_fittedsheet,.pss_left_card .htit_fittedsheet,.pss_left_card .stit_fittedsheet');
                cammiejs.removeColorClass(velems);
                velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_fittedsheet')));
            }
            attr = $(obj).attr('data-flat-sheet-code');
            if (typeof attr !== 'undefined' && attr !== false) {
                var eletoChange = $('.pss_left_card .svg_flat-sheet');
                eletoChange.find('path').attr('fill', attr);
                var velems = $('.pss_left_card .ssit_flatsheet,.pss_left_card .hsit_flatsheet,.pss_left_card .htit_flatsheet,.pss_left_card .stit_flatsheet');
                cammiejs.removeColorClass(velems);
                velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_flatsheet')));
            }
            attr = $(obj).attr('data-pillowcase-code');
            if (typeof attr !== 'undefined' && attr !== false) {
                var eletoChange = $('.pss_left_card .svg_pillowcase');
                eletoChange.find('path').attr('fill', attr);
                var velems = $('.pss_left_card .ssit_pillow,.pss_left_card .hsit_pillow,.pss_left_card .htit_pillow,.pss_left_card .stit_pillow');
                cammiejs.removeColorClass(velems);
                velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_pillow')));
            }
            attr = $(obj).attr('data-sham-code');
            if (typeof attr !== 'undefined' && attr !== false) {
                var eletoChange = $('.pss_left_card .svg_sham');
                eletoChange.find('path').attr('fill', attr);
                var velems = $('.pss_left_card .ssit_sham,.pss_left_card .hsit_sham,.pss_left_card .htit_sham,.pss_left_card .stit_sham');
                if(velems.length >0 )
                {
                    cammiejs.removeColorClass(velems);
                    velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_sham')));
                }
            }
            attr = $(obj).attr('data-duvet-cover-code');
            if (typeof attr !== 'undefined' && attr !== false) {
                var eletoChange = $('.pss_left_card .svg_duvet-cover');
                eletoChange.find('path').attr('fill', attr);
                var velems = $('.pss_left_card .ssit_duvetcover,.pss_left_card .hsit_duvetcover,.pss_left_card .htit_duvetcover,.pss_left_card .stit_duvetcover');
              if(velems.length >0 )
              {
                  cammiejs.removeColorClass(velems);
                  velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_duvetcover')));
              }
            }
            $('.yourdesign-name').html($(obj).attr('data-name'));
            /* $('#mixmatchurl').attr('href',$(obj).attr('data-href'));
      $('.mixmatchurl').attr('href',$('#mixmatchurl').attr('href'));*/
            cammiejs.loadpdppage();
            cammiejs.removeextraimages();
           cammiejs.changeimagetofirst();
        } else {
            // window.location.href = $(obj).attr('data-href').replace('/pages/','/collections/');
            cammiejs.getPDPPageData($(obj).attr('data-href').replace('/pages/', '/collections/'));
  
        }
      $('#hcustinspid').val($(obj).attr('data-id'));
       // $('#mixmatchurl,.mixmatchurl').attr('href',$('#mixmatchurl').attr('data-href')+$(obj).attr('data-id'));
     
    },
    updatelatesttabprop: function(propname, propval) {
        var vstoragekey = "tabinfo" + '-' + $('#hbundletype').val();
        var vUData = window.localStorage.getItem(vstoragekey);
        if (vUData != null) {
            vUData = JSON.parse(vUData);
        } else {
            vUData = {};
        }
        propname = propname;
        vUData[propname] = propval;
        window.localStorage.setItem(vstoragekey, JSON.stringify(vUData));
    },
    updatelatesttabelem: function(tabtype, tabelemid) {
        var vstoragekey = "tabinfo" + '-' + $('#hbundletype').val();
        var vUData = window.localStorage.getItem(vstoragekey);
        if (vUData != null) {
            vUData = JSON.parse(vUData);
        } else {
            vUData = {};
        }
        vUData[tabtype] = tabelemid;
        var vlastactive = "";
        switch (tabtype) {
            case "inspi":
                vlastactive = "color-inspiration-btn";
                break;
            case "colorall":
                vlastactive = "color-all-btn";
                break;
            case "colorgroup":
                vlastactive = "color-group-btn";
                break;
            case "yourdesign":
                vlastactive = "color-yourdesign-btn";
                break;
            case "colorrecent":
                vlastactive = "color-recent-btn";
                break;
            case "coloryourcurrentdesign":
                vlastactive = "color-yourcurrentdesign-btn";
                break;
        }
        vUData["lasttabactive"] = vlastactive;
        vUData["lasttabeleclicked"] = vlastactive;
        window.localStorage.setItem(vstoragekey, JSON.stringify(vUData));
        return vUData;
    },
    getlatesttabelem: function() {
        var vstoragekey = "tabinfo" + '-' + $('#hbundletype').val();
        var vUData = window.localStorage.getItem(vstoragekey);
        if (vUData == null) {
            vUData = "{}";
        }
        return vUData;
    },
    removeallactiveeleintab: function() {
        $('#color-inspiration-wrapper .pscl_color_plt li a.active').removeClass('active');
        $('#color-group-wrapper .pscl_listed li a.active').removeClass('active');
        $('#color-all-wrapper .pscl_listed li a.active').removeClass('active');
        $('#color-recent-wrapper .pscl_listed li a.active').removeClass('active');
        $('#color-yourdesign-wrapper .pscl_color_plt li a.active').removeClass('active');
        $('#color-yourcurrentdesign-wrapper .pscl_listed li a.active').removeClass('active');
    },
    changeinspiration: function(obj) {
        $('#hurltype').val(2);
       $('.urltypekey').text("Collection");
      $('.urltypevalue').html('<span>' + $(obj).attr('data-name') + "</span> by " + $(obj).attr('data-byname'));
      $('.act_color_plt').hide();
      $('.descriptioncolors').removeClass('hide');
        cammiejs.removeallactiveeleintab();
        $(obj).addClass('active');
      $('.color-name-list').hide();
        var attr = $(obj).attr('data-fitted-sheet-code');
        $('.pss_left_card .lp_meet_right_sticky_card').remove();
      
        if (typeof attr !== 'undefined' && attr !== false) {
            var eletoChange = $('.pss_left_card .svg_fitted-sheet');
            eletoChange.find('path').attr('fill', attr);
           /* var velems = $('.pss_left_card .ssit_fittedsheet,.pss_left_card .hsit_fittedsheet,.pss_left_card .htit_fittedsheet,.pss_left_card .stit_fittedsheet');
            cammiejs.removeColorClass(velems);
            velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_fittedsheet'))); */
        }
        attr = $(obj).attr('data-flat-sheet-code');
        if (typeof attr !== 'undefined' && attr !== false) {
            var eletoChange = $('.pss_left_card .svg_flat-sheet');
            eletoChange.find('path').attr('fill', attr);
            /*var velems = $('.pss_left_card .ssit_flatsheet,.pss_left_card .hsit_flatsheet,.pss_left_card .htit_flatsheet,.pss_left_card .stit_flatsheet');
            cammiejs.removeColorClass(velems);
            velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_flatsheet')));*/
        }
        attr = $(obj).attr('data-pillowcase-code');
        if (typeof attr !== 'undefined' && attr !== false) {
            var eletoChange = $('.pss_left_card .svg_pillowcase');
            eletoChange.find('path').attr('fill', attr);
            /*var velems = $('.pss_left_card .ssit_pillow,.pss_left_card .hsit_pillow,.pss_left_card .htit_pillow,.pss_left_card .stit_pillow');
            cammiejs.removeColorClass(velems);
            velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_pillow')));*/
        }
        attr = $(obj).attr('data-sham-code');
        if (typeof attr !== 'undefined' && attr !== false) {
            var eletoChange = $('.pss_left_card .svg_sham');
            eletoChange.find('path').attr('fill', attr);
           /* var velems = $('.pss_left_card .ssit_sham,.pss_left_card .hsit_sham,.pss_left_card .htit_sham,.pss_left_card .stit_sham');
            if(velems.length >0 )
            {
              cammiejs.removeColorClass(velems);
              velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_sham')));
            }*/
        }
        attr = $(obj).attr('data-duvet-cover-code');
        if (typeof attr !== 'undefined' && attr !== false) {
            var eletoChange = $('.pss_left_card .svg_duvet-cover');
            eletoChange.find('path').attr('fill', attr);
           /* var velems = $('.pss_left_card .ssit_duvetcover,.pss_left_card .hsit_duvetcover,.pss_left_card .htit_duvetcover,.pss_left_card .stit_duvetcover,.psrc_list_menu .hsit_duvetcover,.psrc_list_menu .ssit_duvetcover');
          if(velems.length >0 )
            {
              cammiejs.removeColorClass(velems);
              velems.addClass(cammiejs.getColorClass($(obj).find('.ssit_duvetcover')));
            } */
        }
        $('.inspir-name').html($(obj).attr('data-name'));
        $('#mixmatchurl').attr('href', $(obj).attr('data-href'));
        $('.mixmatchurl').attr('href', $('#mixmatchurl').attr('href'));
        var bgallview1 = false;

        attr = $(obj).attr('data-gall_view-1');
        if (typeof attr !== 'undefined' && attr.length > 0) {
            $('.pslc_fixed_card a[data-view="gall_view-1"] img').attr('src', attr);
            $('.gall_view-1 img').attr('src', attr);
            bgallview1 = true;
        }
        var bgallview2 = false;
        attr = $(obj).attr('data-gall_view-2');
        if (typeof attr !== 'undefined' && attr.length > 0) {
            $('.pslc_fixed_card a[data-view="gall_view-2"] img').attr('src', attr);
            $('.gall_view-2 img').attr('src', attr);
            bgallview2 = true;
        }
        var vloadinspiajax = false;
        cammiejs.loadpdppage();
        attr = $(obj).attr('data-url');

        if (typeof attr !== 'undefined' && attr.length > 0) {
            vloadinspiajax = true;
        }
        if (vloadinspiajax) {
            fetch(attr).then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    $('head title').html($(html).find('head title').html());
                    cammiejs.updatereplaceurl($('head title').text(), attr);
                    if ($('.gall_view-1 img').length == 0)
                        $('.pss_left_card').html($(html).find('.pss_left_card').html());
                    if($(html).find('.pss_left_card .lp_meet_right_sticky_card').length >0)
                    {
                       $('.pss_left_card .side_svg_view').prepend($(html).find('.lp_meet_right_sticky_card').prop('outerHTML'));
                      $('.pss_left_card .top_svg_view').prepend($(html).find('.lp_meet_right_sticky_card').prop('outerHTML'))
                    }
                    $('.may_like_card').html($(html).find('.may_like_card').html());
                    cammiejs.loadcarousel();
                    cammiejs.loadcarouselv1();
                    cammiejs.showhideprevnext();
                   cammiejs.changeimagetofirst();
                });
        }
        cammiejs.updatelatesttabelem("inspi", $(obj).attr('data-ikey'));
     
    },
    removeextraimages: function() {
        if ($('.pslc_fixed_card a[data-view="gall_view-1"]').hasClass('active') || $('.pslc_fixed_card a[data-view="gall_view-2"]').hasClass('active')) {
            $('.pslc_fixed_card a:first').trigger('click');
        }
        if ($('.pslc_fixed_card a[data-view="gall_view-1"]').length > 0) {
            $('.pslc_fixed_card a[data-view="gall_view-1"]').remove();
            $('.gall_view-1').remove();
        }
        if ($('.pslc_fixed_card a[data-view="gall_view-2"]').length > 0) {
            $('.pslc_fixed_card a[data-view="gall_view-2"]').remove();
            $('.gall_view-2').remove();
        }
        if ($('.psmc_img_card .gallimg').length < 2) {
            $('.psmc_img_card .psic_left_arrow,.psmc_img_card .psic_right_arrow').remove();
        }
    },
    getColorClass: function(obj) {
        return $.trim(obj[0].className.match(/(^|\s)color_\S+/g)[0]);
    },
    removeColorClass: function(obj) {
        obj.each(function(index) {
            $(this).removeClass(function(index, className) {
                return (className.match(/(^|\s)color_\S+/g) || []).join(' ');
            });
        });
    },
    changeimagetofirst:function() {
      if($('[data-view="svg_view_99"].active').length > 0)
      {
        $('.pslc_fixed_card [data-view="svg_view_0"]').click();
      }
        if($('[data-view="gall_view-99"].active').length > 0)
      {
        $('.pslc_fixed_card [data-view="side_svg_view"]').click();
      }
    },
    changeColor: function(obj, type) {
        $('#hurltype').val(1);
      $('.urltypekey').text("Color");
     
      $('.descriptioncolors').addClass('hide');
      var vtypevalue = $(obj).attr('data-name');
var vaddtypevalue = '';
      $('.act_color_plt').show();
      $('.act_color_plt span').css("background-color",$(obj).attr("data-colorcode"));
      if($(obj).attr('data-colortype').length > 5)
      {
        vaddtypevalue = " by "+ $(obj).attr('data-colortype');
      }
      $('.urltypevalue').html('<span>'+vtypevalue + '</span>'+ vaddtypevalue);
        cammiejs.removeallactiveeleintab();
      $('.color-name-list').hide();
        if(type == "3")
        {
           $('#color-group-wrapper li[data-id="'+$(obj).attr("data-id")+'"]').find('a').addClass('active');
           $('#color-all-wrapper li[data-id="'+$(obj).attr("data-id")+'"]').find('a').addClass('active');
        }
        else{
           $(obj).find('a').addClass('active');
        }
        $('.bigimage img').attr('src', $(obj).find('img').attr('src').replace('.png', '-big.png').replace('.webp', '-big.webp'));
        $('.smallimage img').attr('src', $(obj).find('img').attr('src'));
        cammiejs.setCookie(cammiejs.cookiename, $(obj).attr('data-id'), 1);
        var attrbrandimage = $(obj).attr('data-brandimage');
        if (typeof attrbrandimage !== 'undefined' && attrbrandimage.length >0) {
          if($('.pss_left_card .lp_meet_right_sticky_card img').length >0)
          {
            if($('.pss_left_card .lp_meet_right_sticky_card img').attr('src') != attrbrandimage)
              $('.pss_left_card .lp_meet_right_sticky_card img').attr('src',attrbrandimage);
          }
          else{
            $('.pss_left_card .lp_meet_right_sticky_card').append('<img src="'+attrbrandimage+'" alt="">');
          }
          $('.pss_left_card .lp_meet_right_sticky_card').removeClass('hide');
        }else{
          $('.pss_left_card .lp_meet_right_sticky_card').addClass('hide');     
        }
        var attr = $(obj).attr('data-fitted-sheet-vid');
        var vcolorcode =  $(obj).attr('data-colorcode');
        if (typeof attr !== 'undefined' && attr !== false && attr.length >0) { 
            var vnewcolorcode =  $(obj).attr('data-fitted-sheet-code');
            if (typeof vnewcolorcode !== 'undefined' && vnewcolorcode !== false && vnewcolorcode.length >0) {
               vcolorcode = vnewcolorcode;
            }
            var eletoChange = $('.pss_left_card .svg_fitted-sheet');
            eletoChange.find('path').attr('fill', vcolorcode);
            var vcolorname = $(obj).attr('data-name');
            if($('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').length > 0)
            {
               vcolorname = $('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').attr("data-name");
            }
            $('.clr_fitted-sheet').html(vcolorname);           
            $('.clr_fitted-sheet').closest('li').find('.accl_color_plt span').css('background', vcolorcode);
            var velems = $('.pss_left_card .ssit_fittedsheet,.pss_left_card .hsit_fittedsheet,.pss_left_card .htit_fittedsheet,.pss_left_card .stit_fittedsheet,.psrc_list_menu .hsit_fittedsheet,.psrc_list_menu .ssit_fittedsheet');

            cammiejs.removeColorClass(velems);
            velems.addClass('color_' + $(obj).attr('data-id'));
        }
        attr = $(obj).attr('data-flat-sheet-vid');
        if (typeof attr !== 'undefined' && attr !== false && attr.length >0) {
            var vnewcolorcode =  $(obj).attr('data-flat-sheet-code');
            if (typeof vnewcolorcode !== 'undefined' && vnewcolorcode !== false && vnewcolorcode.length >0) {
               vcolorcode = vnewcolorcode;
            }
            var eletoChange = $('.pss_left_card .svg_flat-sheet');
            eletoChange.find('path').attr('fill', vcolorcode);
            var vcolorname = $(obj).attr('data-name');
            if($('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').length > 0)
            {
               vcolorname = $('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').attr("data-name");
            }
            $('.clr_flat-sheet').html(vcolorname);
            $('.clr_flat-sheet').closest('li').find('.accl_color_plt span').css('background', vcolorcode);
            var velems = $('.pss_left_card .ssit_flatsheet,.pss_left_card .hsit_flatsheet,.pss_left_card .htit_flatsheet,.pss_left_card .stit_flatsheet,.psrc_list_menu .hsit_flatsheet,.psrc_list_menu .ssit_flatsheet');
            cammiejs.removeColorClass(velems);
            velems.addClass('color_' + $(obj).attr('data-id'));
        }
        attr = $(obj).attr('data-pillowcase-vid');
        if (typeof attr !== 'undefined' && attr !== false && attr.length >0) { 
            var vnewcolorcode =  $(obj).attr('data-pillowcase-code');
            if (typeof vnewcolorcode !== 'undefined' && vnewcolorcode !== false && vnewcolorcode.length >0) {
               vcolorcode = vnewcolorcode;
            }
            var eletoChange = $('.pss_left_card .svg_pillowcase');
            eletoChange.find('path').attr('fill', vcolorcode);
            var vcolorname = $(obj).attr('data-name');
            if($('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').length > 0)
            {
               vcolorname = $('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').attr("data-name");
            }
            $('.clr_pillowcase').html(vcolorname);
            $('.clr_pillowcase').closest('li').find('.accl_color_plt span').css('background', vcolorcode);
            var velems = $('.pss_left_card .ssit_pillow,.pss_left_card .hsit_pillow,.pss_left_card .htit_pillow,.pss_left_card .stit_pillow,.psrc_list_menu .hsit_pillow,.psrc_list_menu .ssit_pillow');
            cammiejs.removeColorClass(velems);
            velems.addClass('color_' + $(obj).attr('data-id'));
        }
        attr = $(obj).attr('data-sham-vid');
        if (typeof attr !== 'undefined' && attr !== false && attr.length >0) {
            var vnewcolorcode =  $(obj).attr('data-sham-code');
            if (typeof vnewcolorcode !== 'undefined' && vnewcolorcode !== false && vnewcolorcode.length >0) {
               vcolorcode = vnewcolorcode;
            }
            var eletoChange = $('.pss_left_card .svg_sham');
            eletoChange.find('path').attr('fill', vcolorcode);
           var vcolorname = $(obj).attr('data-name');
            if($('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').length > 0)
            {
               vcolorname = $('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').attr("data-name");
            }
            $('.clr_sham').html(vcolorname);
            $('.clr_sham').closest('li').find('.accl_color_plt span').css('background', vcolorcode);
            var velems = $('.pss_left_card .ssit_sham,.pss_left_card .hsit_sham,.pss_left_card .htit_sham,.pss_left_card .stit_sham,.psrc_list_menu .hsit_sham,.psrc_list_menu .ssit_sham');
            cammiejs.removeColorClass(velems);
            velems.addClass('color_' + $(obj).attr('data-id'));
        }
        attr = $(obj).attr('data-duvet-cover-vid');
        if (typeof attr !== 'undefined' && attr !== false && attr.length >0) {
            var vnewcolorcode =  $(obj).attr('data-duvet-cover-code');
            if (typeof vnewcolorcode !== 'undefined' && vnewcolorcode !== false && vnewcolorcode.length >0) {
               vcolorcode = vnewcolorcode;
            }          
            var eletoChange = $('.pss_left_card .svg_duvet-cover');
            eletoChange.find('path').attr('fill', vcolorcode);
            var vcolorname = $(obj).attr('data-name');
            if($('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').length > 0)
            {
               vcolorname = $('#color-group-wrapper li[data-colorcode="'+vcolorcode+'"]').attr("data-name");
            }
            $('.clr_duvet-cover').html(vcolorname);
            $('.clr_duvet-cover').closest('li').find('.accl_color_plt span').css('background', vcolorcode);
            var velems = $('.pss_left_card .ssit_duvetcover,.pss_left_card .hsit_duvetcover,.pss_left_card .htit_duvetcover,.pss_left_card .stit_duvetcover,.psrc_list_menu .hsit_duvetcover,.psrc_list_menu .ssit_duvetcover');
            cammiejs.removeColorClass(velems);
            velems.addClass('color_' + $(obj).attr('data-id'));
        }

        if (type == '2') {
            //var eletoChange = $('.' + $('.slide-show.active').attr('data-ele').replace("rgt", "svg"));    
            // eletoChange.find('path').attr('fill',$(obj).attr('data-colorcode')); 
            $('.slide-show.active path').attr('fill', $(obj).attr('data-colorcode'));
            $('.slide-show.active').find('.color-name').html($(obj).attr('data-name'));
            $('.pstm_header_card .color-name').html($(obj).attr('data-name'));
            if (!$('.tablinks.active').hasClass('recentTab'))
                cammiejs.loadRecent();
            if (!$('.tablinks.active').hasClass('yourcurrentdesigncolorTab'))
                cammiejs.yourcurrentdesign();
        } else if (type == '1') {
            $('.pstm_color_list .color-name').html($(obj).attr('data-name'));
            $('#mixmatchurl').attr('href', $('#mixmatchurl').attr('data-ihref') + '/' + $(obj).attr('data-colorurl'));
            $('.mixmatchurl').attr('href', $('#mixmatchurl').attr('href'));
            cammiejs.updatereplaceurl('', $('#mixmatchurl').attr('href').replace('/pages/', '/collections/'));
           $('.may_like_card').html('');
        } else if (type == '3') {
            $('.pstm_color_list .color-name').html($(obj).attr('data-name'));
            cammiejs.updatereplaceurl('', $('.pshc_size_card li a.active').attr('data-url') + '/' + $(obj).attr('data-colorurl'));           
        }
        var vacttab = "";
        if ($(obj).closest('.tabcontent').attr('id') == "color-group-wrapper") {
            vacttab = "colorgroup";
        }
        if ($(obj).closest('.tabcontent').attr('id') == "color-all-wrapper") {
            vacttab = "colorall";
        }
        if ($(obj).closest('.tabcontent').attr('id') == "color-recent-wrapper") {
            vacttab = "colorrecent";
        }
        if ($(obj).closest('.tabcontent').attr('id') == "color-yourcurrentdesign-btn") {
            vacttab = "coloryourcurrentdesign";
        }
        cammiejs.updatelatesttabelem(vacttab, $(obj).attr('data-id'));
        cammiejs.removeextraimages();
      cammiejs.changeimagetofirst();

      var vbattr = $(obj).attr('data-available');
      if (typeof vbattr !== 'undefined' && vbattr.length >0) {
        cammiejs.changequantitydd(vbattr);
      }
    },
    changequantitydd:function(numb){
      if($('#IndividualAddtoCartCount').length > 0 && numb > 0)
      {
        var vloop = numb;
        if(numb > 5)
        {
           vloop = 5;
        }
        $('#IndividualAddtoCartCount .dropdown-menu').html('');
        for(var d= 1; d<=vloop; d++)
        {
           $('#IndividualAddtoCartCount .dropdown-menu').append('<li onclick="cammiejs.addtocartdd(this);" data-value="'+d+'">'+d+'</li>')
        }
      }
    },
    resetColor: function() {
        $(".slide-show").each(function(index) {
            $(this).find('.color-name').html($(this).attr('data-icolor-name'));
            var eletoChange = $('.' + $(this).attr('data-ele').replace("rgt", "svg"));
            eletoChange.find('path').attr('fill', $(this).attr('data-icolor-code'));
            $(this).find('path').attr('fill', $(this).attr('data-icolor-code'));
            if ($('.psrc_tab_menu.active').length > 0) {
                cammiejs.backColorTab();
            }
        });
    },
    addRecentcolor: function() {

    },
    changemapname: function() {
        if ($('html').width() < 680) {
            $('map.mob_display_none').each(function(index) {
                $(this).attr('name', '-' + $(this).attr('data-name'));
            });
            $('map.mob_display_show').each(function(index) {
                $(this).attr('name', $(this).attr('data-name'));
            });
        } else {
            $('map.mob_display_none').each(function(index) {
                $(this).attr('name', $(this).attr('data-name'));
            });
            $('map.mob_display_show').each(function(index) {
                $(this).attr('name', '-' + $(this).attr('data-name'));
            });

        }
    },
    openAccordion: function(obj, cityName) {

        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(cityName).style.display = "block";
        $(window).scrollTop($('.grid_title').position().top + $('.grid_title').outerHeight(true));
        $(obj).addClass("active");
        location.hash = cityName;
    },
    showhideprevnext: function() {
        /*if($('.may_like_card').length >0 && ($('.may_like_card .alc_slider li').width() * $('.may_like_card .alc_slider li').length) < $('.may_like_card .alc_slider').width() )
         {
           $('.may_like_card .alc_btn').hide();
         } 
        else{
          $('.may_like_card .alc_btn').show();
        }*/
    },
  loadudcustompage:function() {
    if( cammiejs.getquerystring('ud').length > 0)
    {
      var vcarray =  cammiejs.getquerystring('ud').match(/.{1,2}/g);
      
                        var eletoChange = $('.svg_fitted-sheet,li[data-ele="rgt_fitted-sheet"]');
                        var velecode= $('#color-group-wrapper li[data-id='+vcarray[0].replace(/^0+/, '')+']').attr("data-colorcode");
                        eletoChange.find('path').attr('fill', velecode);
                        $('li[data-ele="rgt_fitted-sheet"]').attr('data-icolor-name', vcodename[velecode].name).attr('data-icolor-code', velecode);
                        $('li[data-ele="rgt_fitted-sheet"] .color-name').html(vcodename[velecode].name);

                        var eletoChange = $('.svg_flat-sheet,li[data-ele="rgt_flat-sheet"]');
                        velecode= $('#color-group-wrapper li[data-id='+vcarray[1].replace(/^0+/, '')+']').attr("data-colorcode");
                        eletoChange.find('path').attr('fill', velecode);
                        $('li[data-ele="rgt_flat-sheet"]').attr('data-icolor-name', vcodename[velecode].name).attr('data-icolor-code', velecode);
                        $('li[data-ele="rgt_flat-sheet"] .color-name').html(vcodename[velecode].name);

                        var eletoChange = $('.svg_pillowcase,li[data-ele="rgt_pillowcase"]');
                        velecode= $('#color-group-wrapper li[data-id='+vcarray[2].replace(/^0+/, '')+']').attr("data-colorcode");
                        eletoChange.find('path').attr('fill', velecode);
                        $('li[data-ele="rgt_pillowcase"]').attr('data-icolor-name', vcodename[velecode].name).attr('data-icolor-code', velecode);
                        $('li[data-ele="rgt_pillowcase"] .color-name').html(vcodename[velecode].name);

                        var eletoChange = $('.svg_sham,li[data-ele="rgt_sham"]');
                       if(eletoChange.length > 0)
                       {
                         velecode= $('#color-group-wrapper li[data-id='+vcarray[3].replace(/^0+/, '')+']').attr("data-colorcode");
                          eletoChange.find('path').attr('fill', velecode);
                          $('li[data-ele="rgt_sham"]').attr('data-icolor-name', vcodename[velecode].name).attr('data-icolor-code', velecode);
                          $('li[data-ele="rgt_sham"] .color-name').html(vcodename[velecode].name);
                       }

                        var eletoChange = $('.svg_duvet-cover,li[data-ele="rgt_duvet-cover"]');
                       if(eletoChange.length > 0)
                       {
                         velecode= $('#color-group-wrapper li[data-id='+vcarray[4].replace(/^0+/, '')+']').attr("data-colorcode");
                          eletoChange.find('path').attr('fill', velecode);
                          $('li[data-ele="rgt_duvet-cover"]').attr('data-icolor-name', vcodename[velecode].name).attr('data-icolor-code',velecode);
                          $('li[data-ele="rgt_duvet-cover"] .color-name').html(vcodename[velecode].name);
                       }
  }
  }
};

$(document).ready(function() {
if($('.freeshippingtext').length >0)
{
   $(window).scroll(function() { 
    if ($(this).scrollTop() >= $('.freeshippingtext').position().top) {
      $('.fixed_footer').removeClass('hide');
    }
    else{
      $('.fixed_footer').addClass('hide');
    }
  });
}
  
if($('#mixmatchurl,.mixmatchurl').length >0)
           $('#mixmatchurl,.mixmatchurl').attr('href',$('#mixmatchurl').attr('data-href'));
  if ($('#hcustinspid').length > 0 && $('#hcustinspid').val().length > 0) {
              
      
    const vcustid =  cammiejs.getquerystring('id');
          $('#mixmatchurl,.mixmatchurl').attr('href',$('#mixmatchurl').attr('data-href') + vcustid);
          $('#hcustinspid').val(vcustid);
        }
    window.addEventListener("DOMContentLoaded", function() {
        cammiejs.review.init();
    });

    cammiejs.loadAccordion();
    cammiejs.loadpdppage();

    $(window).resize(function() {
        cammiejs.changemapname();
    });
    cammiejs.changemapname();
    $(document).on("click", ".area_duvet-cover,.area_fitted-sheet,.area_flat-sheet,.area_pillowcase,.area_sham", function() {
        var eletoClick = $('li[data-ele="' + $(this).attr('class').replace("area", "rgt") + '"]');       
        eletoClick.trigger("click");
    }); 
     $(document).on("mousemove",".area_duvet-cover,.area_fitted-sheet,.area_flat-sheet,.area_pillowcase,.area_sham", function(event) {
      var eletoClick = $('li[data-ele="' + $(this).attr('class').replace("area", "rgt") + '"]');  
      
       var relX = event.pageX - $(this).offset().left - $('.pic_tooltip_card').width() /2;
          var relY = event.pageY - $(this).offset().top - $('.pic_tooltip_card').height()- 10;  
      
          $('.pic_tooltip_card p').html(eletoClick.find('h4').html()); 
       
       $('.pic_tooltip_card').css({top: relY, left:  relX,display:'flex'});
    });
   $(document).on("mouseleave",".psmc_img_card", function(event) { 
      $('.pic_tooltip_card').hide();
    });

  
  
 
    if ($('.pss_right_card').not('.bodydontadd').length > 0) {
       var vlftcard = $('.pss_left_card').height();
       var aTop = $('.pss_right_card').position().top;
        $(window).scroll(function() {            
          if ($('html').width() < vMobilesize) {
            if ($(this).scrollTop() >= aTop && !$('body').hasClass('mob_show_card')) {
                $('body').addClass('mob_show_card').css('padding-top',vlftcard+100+26);
            } else if($(this).scrollTop() < aTop) {
                $('body').removeClass('mob_show_card').css('padding-top',0);
            }
          }
          else{
              $('body').css('padding-top',0).removeClass('mob_show_card');
          }
        });
    }
    if ($('#hptype').val() == "1") {
        cammiejs.loadyourdesign();
        if (window.location.href.indexOf("cust?id=") > -1 & $('#color-yourdesign-wrapper a[data-id="' + $('#hcustinspid').val() + '"]').length >0) {
            $('#color-yourdesign-btn').trigger('click');
            cammiejs.changeyourdesign($('#color-yourdesign-wrapper a[data-id="' + $('#hcustinspid').val() + '"]'), 2);
        }
        else if(window.location.href.indexOf("cust?id=") > -1)
        {
          cammiejs.loadurldesign();
        }
        else if(window.location.href.indexOf("cust?ud=") > -1) {
          cammiejs.loadudcustompage();
        }
        else if ($('#hurltype').val() == "1") {
            $('#color-group-btn').trigger('click');
            $('#color-group-wrapper .pscl_listed li[data-id="' + $("#hcolorid").val() + '"] a').addClass('active');
            cammiejs.updatelatesttabprop("lasttabeleclicked", "color-group-btn");
            cammiejs.updatelatesttabprop("colorgroup", $("#hcolorid").val());
        } else if ($('#hurltype').val() == "2") {
            $('#color-inspiration-btn').trigger('click');
            cammiejs.updatelatesttabprop("lasttabeleclicked", 'color-inspiration-btn');
            cammiejs.updatelatesttabprop("inspi", $('#hinspirationkey').val());
        } else {
            cammiejs.updatelatesttabprop("lasttabactive", "color-inspiration-btn");
            cammiejs.updatelatesttabprop("lasttabeleclicked", "color-group-btn");
            $('#color-group-wrapper .pscl_listed li[data-colorcode="#f3f2fc"] a').addClass('active');
            cammiejs.updatelatesttabprop("colorgroup", $('#color-group-wrapper .pscl_listed li[data-colorcode="#f3f2fc"]').attr('data-id'));
        }
        cammiejs.showhideprevnext();
        var vCokVal = cammiejs.getCookie('sac') + "";
        if (vCokVal == "1") {
            cammiejs.setCookiev1('sac', 0, -1);
            $('#setAddtoCart').click();
        }
    }
    if ($('#hptype').val() == "2") {
       cammiejs.yourcurrentdesign();
        cammiejs.loadconfigcustompage();
    }
    if ($('#hptype').val() == "3") {
        $('#color-group-wrapper .pscl_listed li[data-id="' + $("#hcolorid").val() + '"] a').addClass('active');
        cammiejs.updatelatesttabprop("lasttabeleclicked", "color-group-btn");
        cammiejs.updatelatesttabprop("colorgroup", $("#hcolorid").val());

    }
    if ($('#hptype').val() == "8") {
        var vhash = location.hash.replace("#", "");
        if (vhash == "Inspiration") {
            $('.tablinks').eq(0).trigger("click");
        } else if (vhash == "SheetSet") {
            $('.tablinks').eq(1).trigger("click");
        } else if (vhash == "Individual") {
            $('.tablinks').eq(2).trigger("click");
        }
    }
    //cammiejs.blockerinit();
    if ($('#hptype').val() == "5" || $('.our-color-carousel').length > 0) {
        var $carousel = $('.our-color-carousel').flickity({
            "contain": true,
            "pageDots": false,
            "groupCells": true,
            "groupCells": 4,
            "draggable": true,
            "imagesLoaded": true
        });
        $("#carouselrange").on('input', function() {
            var newval = $(this).val();
            $carousel.flickity('select', newval);
        });
        $carousel.on('select.flickity', function() {
            $("#carouselrange").val($carousel.data('flickity').selectedIndex);
        });
    }
    cammiejs.loadcarousel();
    cammiejs.loadcarouselv1();
    $(".list_inspi_li")
        .mouseenter(function() {
            $(".list_inspi_clr").not('.hide').addClass('hide');
            $(this).find(".list_inspi_clr").removeClass('hide');
            if ($(this).hasClass('moverchangeimg')) {
                $(this).find(".psic_shadow_img,.psic_highlight_img").hide();
                $(this).find(".gics_link img").attr('src', $(this).find(".gics_link img").attr('data-moverimg'));
            }
        })
        .mouseleave(function() {
            $(this).find(".list_inspi_clr").addClass('hide');
            if ($(this).hasClass('moverchangeimg')) {
                $(this).find(".gics_link img").attr('src', $(this).find(".gics_link img").attr('data-img'));
                $(this).find(".psic_shadow_img,.psic_highlight_img").show();
            }
        });
         /*$(".list_indivi_li").mouseenter(function() {
            $(".list_indivi_clr").not('.hide').addClass('hide');
            $(this).find(".list_indivi_clr").removeClass('hide');            
        })
        .mouseleave(function() {
            $(this).find(".list_indivi_clr").addClass('hide');
        });*/  
      if( $('.qtc_container').length >0 && $('html').width() < 768)
      {
          $('.qtc_container').flickity({ 
              "pageDots": true,
              "groupCells": false,
              "draggable": true,
              "prevNextButtons": false
          }); 
      }
      if( $('.fixed_footer').hasClass('ff_swatch_box'))
      {
         $(window).scroll(function() { 
            if ($(this).scrollTop() >= $('.get_started_card').position().top) {
                $('.fixed_footer').show();
            } else{
                $('.fixed_footer').hide();
            }
         });
      }
});
 
class ScrollToggle {
    constructor(element) {
        this.container = element;
        this.toggles = this.container.querySelectorAll('.scroll-toggle__button');
        this.list = this.container.querySelector('.scroll-toggle__list');
        this.listItems = this.list.querySelectorAll('.scroll-toggle__list-item')
        this.scrollValue = 0;
    }
    init() {

        this.toggles.forEach(toggle => {
            toggle.addEventListener('mousedown', (e) => {
                this.move(e.target);
            });
            toggle.addEventListener('mouseup', (e) => {
                this.stop();
            });
            /* toggle.addEventListener('click', (e) => {
                  this.move(e.target);
              });*/
        });


        // $(this.toggles).parent().parent().hide();/

    }
    move(target) {
        if (target.classList.contains('scroll-toggle__button--right')) {
            this.interval = setInterval(() => {
                this.list.scrollLeft += 1;
            }, 1);
        } else if (target.classList.contains('scroll-toggle__button--left')) {
            this.interval = setInterval(() => {
                this.list.ScrollLeft = this.scrollValue;
                this.list.scrollLeft -= 1;
            }, 1);
        }
    }
    stop() {
        if (this.list.scrollLeft > 0) {
            this.scrollValue = this.list.scrollLeft;
        }
        clearInterval(this.interval);
    }
}